{
  "\"chart.tooltip.substat.phase\"": "Fáze {number, select, 0 {1} 1 {2} 2 {3} other {{number}}}",
  "\"chart.tooltip.substat.pv_string\"": "{inverterName}, String {stringNumber}",
  "animation.battery": "Batéria",
  "animation.boiler": "Bojler",
  "animation.consumption": "Dom",
  "animation.electrical_grid": "Sieť",
  "animation.hp": "Tepelko",
  "animation.photovoltaics": "FVE",
  "animation.wallbox": "Wallbox",
  "animation.wind": "Vítr",
  "app_messages.battery_max_soc": "Nabitie batérie na nastavené maximálne SOC {maxSoc, number, ::.##}%",
  "app_messages.battery_min_soc": "Vybitie batérie na nastavené minimálne SOC {minSoc, number, ::.##}%",
  "app_messages.body.battery_max_soc": "Aktuálna úroveň nabitia batérie je {currentSoc, number, ::.##}%.",
  "app_messages.body.battery_min_soc": "Aktuálna úroveň nabitia batérie je {currentSoc, number, ::.##}%.",
  "app_messages.body.heat_pump_limit_exceeded": "Bol prekročený dnešný limit spotreby tepelného čerpadla. Limit je {value, number, ::.##} kWh.",
  "app_messages.body.heat_water_limit_exceeded": "Bol prekročený dnešný limit ohrevu vody. Limit je {value, number, ::.##} kWh.",
  "app_messages.body.heat_water_max_temperature": "Dnes už došlo k nahriatiu bojlera na požadovanú maximálnu teplotu {maxTemperature, number, ::.##}°C.",
  "app_messages.body.home_limit_exceeded": "Bol prekročený dnešný limit spotreby domácnosti. Limit je {value, number, ::.##} kWh.",
  "app_messages.body.inverter_production_mwh": "Tento rok vám vaša fotovoltaická elektrárna už vyrobila {inverterProductionValue, number, ::.##} MWh.",
  "app_messages.body.spot_daily_prediction": "Denná predpoveď: {pvPrediction, select, true {Výroba elektrárne: {pvPredictionValue, number, ::.##} kWh. } other {} } {homePrediction, select, true {Bežná spotreba domu: {homePredictionValue, number, ::.##} kWh. } other {} } {batteryPrediction, select, true {Dispozičná akumulácia batérie: {batteryPredictionValue, number, ::.##} kWh. } other {} } {hwPrediction, select, true {Dispozičná akumulácia bojleru: {hwPredictionValue, number, ::.##} kWh. } other {} } {hpPrediction, select, true {Tepelné čerpadlo je {hpPredictionValue, number, ::.##} kWh. } other {} } {salePrediction, select, true {Zostávajúca energia na predaj prebytočkov je {salePredictionValue, number, ::.##} kWh. } other {} }",
  "app_messages.body.spot_daily_summary": "Dnes na spotu: {nothingToReport, select, true {Nie je nič v pláne.} other { {energyForSale, select, true {V pláne je rannej predaj do siete. } other {} } {negativeIntervals, select, false {} other {Záporná cena ({negativeIntervals}), pri ktorej sa obmedzí pretok. } } {chargingIntervals, select, false {} other {Plán nabíjania batérie ({chargingIntervals}). } } {dischargingIntervals, select, false {} other {Plán vybíjania batérie do siete ({dischargingIntervals}). } } } }",
  "app_messages.body.spot_negative_price_start": "Aktuálna cena na spotu je po odpočítaní provízie záporná. Provízia nastavená v Infigy je vo výške {spotOffsetPrice, number, ::.##} Kč. Aktuálna cena spotu je {spotNegativePrice, number, ::.##} Kč.",
  "app_messages.body.spot_negative_price_stop": "Aktuálna cena na spotu už nie je záporná a je vo výške {spotNegativePrice, number, ::.##} Kč. Provízia je v Infigy nastavená vo výške {spotOffsetPrice, number, ::.##} Kč",
  "app_messages.body.wallbox_limit_exceeded": "Bol prekročený dnešný limit nabíjania elektromobilu. Limit je {value, number, ::.##} kWh.",
  "app_messages.body.wallbox_stop_charging": "V tomto cykle bolo dodané {wallboxConsumptionCycleValue, number, ::.##} kWh energie.",
  "app_messages.button": "Smazať",
  "app_messages.cancel": "Zrušiť",
  "app_messages.confirm": "Smazať",
  "app_messages.confirm.title": "Naozaj chcete smazať všetky správy?",
  "app_messages.detail_dialog.close": "Prečítané",
  "app_messages.heat_pump_limit_exceeded": "Bol prekročený dnešný limit spotreby tepelného čerpadla",
  "app_messages.heat_water_limit_exceeded": "Bol prekročený dnešný limit ohrevu vody",
  "app_messages.heat_water_max_temperature": "Dosiahnutá požadovaná maximálna teplota vody",
  "app_messages.home_limit_exceeded": "Bol prekročený dnešný limit spotreby domácnosti",
  "app_messages.inverter_connected": "Nadviazanie komunikácie so striedačom",
  "app_messages.inverter_disconnected": "Strata komunikácie so striedačom",
  "app_messages.inverter_production_mwh": "Míľnik vo výrobe FVE",
  "app_messages.load_more": "Načítať viac",
  "app_messages.no_messages": "Zatiaľ tu nie sú žiadne notifikácie",
  "app_messages.spot_daily_prediction": "Denná predpoveď",
  "app_messages.spot_daily_summary": "Denný súhrn plánu spotu",
  "app_messages.spot_negative_price_start": "Cena spotu je záporná",
  "app_messages.spot_negative_price_stop": "Cena spotu už nie je záporná",
  "app_messages.spot_start_charging_battery": "Začalo nabíjanie batérie podľa spotovej ceny",
  "app_messages.spot_start_discharging_battery": "Začalo vybíjanie batérie do siete podľa spotovej ceny",
  "app_messages.spot_stop_charging_battery": "Nabíjanie batérie podľa spotovej ceny bolo ukončené",
  "app_messages.spot_stop_discharging_battery": "Vybíjanie batérie do siete podľa spotovej ceny bolo ukončené",
  "app_messages.test": "Testovacia notifikácia",
  "app_messages.title": "Smazať všetky správy",
  "app_messages.utility_loss_start": "Zaznamenali sme výpadok distribučnej siete",
  "app_messages.utility_loss_stop": "Výpadok distribučnej siete bol odstránený",
  "app_messages.wallbox_limit_exceeded": "Bol prekročený dnešný limit nabíjania elektromobilu",
  "app_messages.wallbox_start_charging": "Začalo nabíjania elektromobilu",
  "app_messages.wallbox_stop_charging": "Nabíjanie elektromobilu bolo ukončené",
  "app_update_overlay.subtitle": "Prosím vyčkajte. Po dokončení aktualizácie sa aplikácia reštartuje a okno v prehliadači sa automaticky obnoví",
  "app_update_overlay.title": "Aktualizácia prebieha",
  "audit_log.error": "Chyba pri načítavaní",
  "audit_log.item.author": "Autor",
  "audit_log.item.date": "Dátum",
  "audit_log.item.payload": "Udalosť",
  "audit_log.item.type": "Typ",
  "audit_log.title": "Audit Log",
  "audit_log_delete.button": "Smazať",
  "audit_log_delete.cancel": "Zrušiť",
  "audit_log_delete.confirm": "Smazať",
  "audit_log_delete.confirm.title": "Naozaj chcete smazat všetky záznamy v audit logu?",
  "audit_log_delete.title": "Smazať audit log",
  "azRouters.add": "Pridajte nový AZ router",
  "azRouters.addButton": "Pridajte",
  "azRouters.clientId": "Modbus ID:",
  "azRouters.clientId.value": "Modbus ID: {id}.",
  "azRouters.counts": "OK {ok} / Chyba {err}",
  "azRouters.empty": "Nejsou nakonfigurovány žiadne AZ routery.",
  "azRouters.name": "Názov",
  "azRouters.status.error": "Chyba",
  "azRouters.status.ok": "OK",
  "azRouters.status.starting": "Spúšťa sa",
  "azRouters.title": "AZ routery",
  "bez_dodavatele.business_flexibility.title": "Obchodná flexibilita",
  "bez_dodavatele.enabled": "Integrácia zapnutá",
  "bez_dodavatele.region": "Kód kraja",
  "bez_dodavatele.title": "bezDodavatele",
  "boiler.blocking": "Blokácia ohrevu",
  "boiler.common": "Všeobecné informácie",
  "boiler.common.phase_3": "Fáze 3:",
  "boiler.common.power": "Aktuálny odber",
  "boiler.common.power.phase_1": "Fáze 1:",
  "boiler.common.power.phase_2": "Fáze 2:",
  "boiler.common.power_today": "Dnešná spotreba:",
  "boiler.common.power_year": "Ročná spotreba:",
  "boiler.common.temperature": "Aktuálna teplota",
  "boiler.common.total": "Celková spotreba",
  "boiler.settings": "Nastavenie",
  "boiler.settings.hdo": "Riadenie bežného ohrevu podľa HDO čias",
  "boiler.settings.hdo.subtitle": "Časy pre HDO musia byť nastavené v všeobecnom nastavení",
  "boiler.settings.min_soc": "Blokácia ohrevu pri výpadku siete",
  "boiler.settings.min_soc.subtitle": "Nabitie batérie, od ktorého dôjde k blokácii ohrevu pri výpadku siete",
  "boiler.settings.min_soc_utility": "Blokácia ohrevu pri dostupnej sieti",
  "boiler.settings.min_soc_utility.subtitle": "Nabitie batérie, od ktorého dôjde k blokácii ohrevu",
  "boiler.settings.spot-hi": "Blokovať ohrev pri vysokej cene spotu",
  "boiler.settings.spot-mi": "Blokovať ohrev pri strednej cene spotu",
  "boiler.settings.temp": "Nastavená teplota",
  "boiler.settings.temp.subtitle": "Bežná teplota, ktorá je k dispozícii vždy",
  "boiler.settings.temp_ek": "Teplota z FVE pomocou EK",
  "boiler.settings.temp_ek.subtitle": "Predohrievacía teplota, ktorá je len z prebytočkov",
  "boiler.settings.temp_spot": "Teplota zo spotu pomocou EK",
  "boiler.settings.temp_spot.subtitle": "Predohrievacía teplota, ktorá je len z nízkej ceny",
  "boiler.statistics": "Výkon bojlera",
  "boiler.statisticsTemp": "Teplota bojlera",
  "boiler.status": "Režim bojlera",
  "boiler.status.home": "Režim bojlera",
  "boiler_test_trigger.button": "Otestovať bojler",
  "boiler_test_trigger.button.running": "Test prebieha",
  "boiler_test_trigger.subtitle": "Overí správne zapojenie a zadaný výkon patrony bojlera.",
  "boiler_test_trigger.title": "Testovanie bojlera",
  "boiler_test_wizard.acknowledge.condition": "Pre správny test bojlera je nutné, aby bol spotreba v objekte konštantný a alebo nulový. Akékoľvek výkyvy vo spotrebe môžu test ovplyvniť. Aktuálny spotreba objektu je {power}",
  "boiler_test_wizard.acknowledge.config": "Aktuálne je nastaven {phaseLabel} bojler o celkové výkonu {power}. Tieto hodnoty musia byť zadané dle štítku patrony.",
  "boiler_test_wizard.acknowledge.confirm": "Potvrdiť",
  "boiler_test_wizard.acknowledge.phase1": "1-fázový",
  "boiler_test_wizard.acknowledge.phase3": "3-fázový",
  "boiler_test_wizard.acknowledge.phase_option": "{phase}. fáza",
  "boiler_test_wizard.acknowledge.phase_select": "Vyberte fázy, ktoré sa majú otestovať. Neoznačené fázy budú preskočené.",
  "boiler_test_wizard.acknowledge.phase_select_empty": "Vyberte aspoň jednu fázu.",
  "boiler_test_wizard.acknowledge.start": "Otestovať bojler",
  "boiler_test_wizard.acknowledge.title": "Informácie k testu",
  "boiler_test_wizard.result.after": "Spotreba objektu po aktivácii",
  "boiler_test_wizard.result.before": "Spotreba objektu pred aktiváciou",
  "boiler_test_wizard.result.close": "Zavrieť",
  "boiler_test_wizard.result.correct": "Spotreba bojlera je správna",
  "boiler_test_wizard.result.detail_toggle": "Podrobný test",
  "boiler_test_wizard.result.header": "Výsledok testu:",
  "boiler_test_wizard.result.phase_header": "{phase}. fáze",
  "boiler_test_wizard.result.real_power": "Odhadovaný výkon bojlera",
  "boiler_test_wizard.result.rerun": "Spustiť test znova",
  "boiler_test_wizard.result.set_power": "Zadaný výkon",
  "boiler_test_wizard.result.stable": "Merenie bolo stabilné",
  "boiler_test_wizard.result.title": "Výsledok testu",
  "boiler_test_wizard.running.activate": "Aktivácia fáze bojlera",
  "boiler_test_wizard.running.after": "Spotreba objektu je {power}",
  "boiler_test_wizard.running.before": "Spotreba objektu pred testom je {power}",
  "boiler_test_wizard.running.measuring": "Prebieha meranie…",
  "boiler_test_wizard.running.phase": "Testujeme fázu {phase}",
  "boiler_test_wizard.running.real_power": "Odhadovaný výkon bojlera je {power}",
  "boiler_test_wizard.running.remaining": "Zostáva približne {seconds} s",
  "boiler_test_wizard.running.reset": "Nulovanie spotreby",
  "boiler_test_wizard.running.result_fail": "Test fázy nie je správny",
  "boiler_test_wizard.running.result_ok": "Test fázy je správny",
  "boiler_test_wizard.running.stable": "Spotreba je stabilná",
  "boiler_test_wizard.running.title": "Prebieha test",
  "boiler_test_wizard.running.unstable": "Merenie nebolo stabilné",
  "boiler_test_wizard.title": "Testovanie bojlera",
  "cancel": "Zrušiť",
  "chart.range.this_week": "Minulý týždeň",
  "chart.range.today": "Posledných 24{nbsp}hodin",
  "chart.tooltip.active_condition.title": "Aktuálny režim:",
  "chart.tooltip.active_condition.value.battery": "Batéria",
  "chart.tooltip.active_condition.value.compressor-blocked": "Blokácia kompresora, nízky stav batérie",
  "chart.tooltip.active_condition.value.cooling": "Chladenie",
  "chart.tooltip.active_condition.value.error": "Chyba",
  "chart.tooltip.active_condition.value.heating": "Vykurovanie",
  "chart.tooltip.active_condition.value.hot-water": "Ohrev teplej vody",
  "chart.tooltip.active_condition.value.inactive": "Neaktívny",
  "chart.tooltip.active_condition.value.manual": "Manuálny",
  "chart.tooltip.active_condition.value.not-connected": "Nemožno nadviazať spojenie",
  "chart.tooltip.active_condition.value.not-licensed": "Nie je licencované",
  "chart.tooltip.active_condition.value.off": "Vypnuté",
  "chart.tooltip.active_condition.value.overflow": "Pretok",
  "chart.tooltip.active_condition.value.pool": "Ohrev bazéna",
  "chart.tooltip.active_condition.value.spot": "Spot",
  "chart.tooltip.active_condition.value.time": "Časový",
  "chart.tooltip.control_mode.title": "Riadené podľa:",
  "chart.tooltip.control_mode.value": "{mode, select, photovoltaic {Fotovoltaika} grid {Distribučná sieť} spot {Spot} flexibility {Flexibilita} error {Chyba} other {{mode}} }",
  "chart.tooltip.wallbox_authorization_card_id.title": "Autorizačná karta:",
  "charts.error.dialog.title": "Pri načítavaní štatistík došlo k chybe",
  "charts.mode.day": "Den",
  "charts.mode.week": "Týden",
  "charts.mode.year": "Rok",
  "charts.summary.value": "Celkom {value}",
  "close": "Zavrieť",
  "cloud_plugs.bat": "Riadenie podľa batérie",
  "cloud_plugs.battery.battery_start": "Zapnúť pri nabití",
  "cloud_plugs.battery.battery_start.subtitle": "Nabitie batérie, pri ktorom sa aktivuje zásuvka",
  "cloud_plugs.battery.battery_stop": "Vypnúť pri nabití",
  "cloud_plugs.battery.battery_stop.subtitle": "Nabitie batérie, pri ktorom sa vypne zásuvka",
  "cloud_plugs.battery.on": "Aktivní",
  "cloud_plugs.battery_charged": "Nabitie batérie",
  "cloud_plugs.condition": "Podmínka",
  "cloud_plugs.condition.and": "A",
  "cloud_plugs.condition.or": "Nebo",
  "cloud_plugs.led_mode.battery.subtitle": "Podsvietené aktívne, ak má batéria aspoň 95%",
  "cloud_plugs.led_mode.battery.switch.title": "Podsvietené pri sepnutej zásuvke",
  "cloud_plugs.led_mode.battery.title": "Podsvietené pri nabitej batérii",
  "cloud_plugs.led_mode.mode": "{mode, select, unknown {---} off {Vypnuté} switch {} power {Podľa príkonu} other {Neznámy}}",
  "cloud_plugs.led_mode.overflow.subtitle": "Podsvietené aktívne, ak dôjde k stabilnému pretoku",
  "cloud_plugs.led_mode.overflow.title": "Podsvietené pri pretoku",
  "cloud_plugs.led_mode.switch.subtitle": "Podsvietené aktívne, ak je zásuvka sepnutá",
  "cloud_plugs.led_mode.title": "LED signalizácia",
  "cloud_plugs.list.id": "ID",
  "cloud_plugs.list.led_mode": "LED signalizácia",
  "cloud_plugs.list.online": "Online",
  "cloud_plugs.list.relay": "Relé",
  "cloud_plugs.list.title": "Status",
  "cloud_plugs.overflow": "Riadenie podľa pretoku",
  "cloud_plugs.overflow.help": "Zapínanie zásuvky pri definovanom pretoku do distribučnej siete.",
  "cloud_plugs.overflow.on": "Aktívny",
  "cloud_plugs.overflow.startPower": "Zapnúť pri odbore zo siete",
  "cloud_plugs.overflow.startPower.help": "Zásuvka sa zapne, ak je pretok v nastavenej výške po definovaný interval oneskorenie. Ak je hodnota nastavená na - 1500W a oneskorenie zapnutí je 5 minut, tak zásuvka sepne pri pretoku do siete vo výške alespoň 1500W po dobu 5 minut.",
  "cloud_plugs.overflow.startPower.subtitle": "Záporná hodnota je pretok, kladná hodnota je odber",
  "cloud_plugs.overflow.stopPower": "Vypnúť pri odberu zo siete",
  "cloud_plugs.overflow.stopPower.help": "Zásuvka sa vypne, ak je odber vyšší než nastavený po definovaný interval oneskorenie. Ak je hodnota nastavená na 100W a oneskorenie vypnutí je 5 minut, tak zásuvka vypne pri odberu zo siete vo výške minimálne 100W po dobu 5 minut.",
  "cloud_plugs.overflow.stopPower.subtitle": "Záporná hodnota je pretok, kladná hodnota je odber",
  "cloud_plugs.pv_power": "Riadenie podľa výkonu FVE",
  "cloud_plugs.pv_power.help": "Zapínanie zásuvky pri definovanom výkone FVE.",
  "cloud_plugs.pv_power.on": "Aktívny",
  "cloud_plugs.pv_power.startPower": "Zapnúť pri výrobe FVE",
  "cloud_plugs.pv_power.startPower.help": "Zásuvka sa zapne, ak je výkon FVE väčší než nastavená hodnota. Ak je hodnota nastavená na 1000W, tak zásuvka sepne pri výrobe FVE vo výške alespoň 1000W.",
  "cloud_plugs.pv_power.stopPower": "Vypnúť pri výrobe FVE",
  "cloud_plugs.pv_power.stopPower.help": "Zásuvka sa vypne, ak je výkon FVE menší než nastavená hodnota. Ak je hodnota nastavená na 500W, tak zásuvka vypne pri výrobe FVE nižšie než 500W.",
  "cloud_plugs.time": "Riadenie podľa času",
  "cloud_plugs.time.on": "Aktivní",
  "cloud_plugs.title": "Zásuvky",
  "cloud_plugs.turn_off": "Vypnúť",
  "cloud_plugs.turn_on": "Zapnúť",
  "dark_mode.dark": "Tmavý",
  "dark_mode.light": "Svetlý",
  "dark_mode.system": "Systém",
  "delta_green.battery_max_power_in": "Maximálny výkon batérie IN (W)",
  "delta_green.battery_max_power_out": "Maximálny výkon batérie OUT (W)",
  "delta_green.business_flexibility.title": "Obchodná flexibilita",
  "delta_green.connected": "Stav",
  "delta_green.enabled": "Integrácia zapnutá",
  "delta_green.last_messages": "Posledné správy",
  "delta_green.last_messages.date": "Čas",
  "delta_green.last_messages.payload": "Správa",
  "delta_green.last_messages.topic": "Topic",
  "delta_green.pv_orientation": "Orientace fotovoltaiky",
  "delta_green.title": "Delta Green",
  "des_battery_container.status.error": "Chyba",
  "des_battery_container.status.none": "Neznámy stav",
  "des_battery_container.status.off": "Vypnuté",
  "des_battery_container.status.run": "Bežný režim",
  "des_battery_container.status.sleep": "Režim spánku",
  "dev.cloud_plugs.mqtt_cloud.connected": "Stav MQTT Cloud pripojenia",
  "dev.cloud_plugs.title": "Cloudové zásuvky",
  "dev.inverter_config.connection.lan": "LAN",
  "dev.inverter_config.connection.rs485": "RS485",
  "dev.inverter_config.connection.rs485_hint": "Adresa a port sa preberajú z dosky ({host}:{port}).",
  "dev.inverter_config.rename_warning": "Premenovanie kľúča z \"{from}\" na \"{to}\" osirie historické dáta — štatistiky aj načítavanú vyrobenú energiu, ktoré sú vedené pod pôvodným kľúčom.",
  "dev.inverter_config.search.open": "Vyhľadať striedač",
  "dev.inverter_config.search.title": "Vyhľadať striedač",
  "dev.inverter_config.stats.all": "Všetko",
  "dev.inverter_config.status.counts": "OK {ok} / Chýb {err}",
  "dev.inverter_config.status.error": "Chyba",
  "dev.inverter_config.status.ok": "OK",
  "dev.inverter_config.status.starting": "Spúšťa sa",
  "dev.inverter_config.title": "Konfigurácia striedačov",
  "dev.link": "Dev",
  "dev_app_messages.test_send": "Testovacia notifikácia",
  "dev_app_messages.test_send.button": "Odoslať",
  "dev_homepage.app_messages.title": "Notifikace",
  "dev_homepage.title": "Vývojové menu",
  "dev_status_log.empty": "Zatiaľ žiadne dáta",
  "dev_status_log.error": "Chyba pri načítaní",
  "dev_status_log.title": "Status log",
  "dev_status_log.today": "Dnes",
  "dhcp_host.address": "IP adresa",
  "dhcp_host.create.title": "Nový DHCP host",
  "dhcp_host.edit.title": "Upraviť DHCP host",
  "dhcp_host.mac": "MAC adresa",
  "dhcp_host.name": "Názov",
  "dhcp_hosts.remove.cancel": "Zrušiť",
  "dhcp_hosts.remove.confirm": "Smazať",
  "dhcp_hosts.remove.confirm.title": "Naozaj chcete odfixovat adresu DHCP hosta?",
  "dhcp_leases.ip": "IP adresa",
  "dhcp_leases.mac": "MAC adresa",
  "dhcp_leases.make_static.cancel": "Zrušiť",
  "dhcp_leases.make_static.confirm": "Pridať",
  "dhcp_leases.make_static.confirm.title": "Naozaj chcete zafixovat adresu DHCP hosta?",
  "dhcp_leases.name": "Meno",
  "dhcp_leases.next_renewal": "Ďalšie obnovenie",
  "dhcp_leases.title": "DHCP Leases",
  "ean": "EAN",
  "electree.business_flexibility.title": "Obchodná flexibilita",
  "electree.connected": "Stav pripojenia",
  "electree.enabled": "Integrácia zapnutá",
  "electree.last_messages": "Posledné správy",
  "electree.last_messages.date": "Čas správy",
  "electree.last_messages.payload": "Správa",
  "electree.last_messages.topic": "Téma",
  "electree.title": "Electree",
  "electrical_grid.common": "Všeobecné informácie",
  "electrical_grid.common.overflow": "Celkový pretok do siete",
  "electrical_grid.common.overflow_today": "Dnešný pretok do siete:",
  "electrical_grid.common.overflow_year": "Ročný pretok do siete:",
  "electrical_grid.common.power": "Aktuálny odber",
  "electrical_grid.common.power.phase_1": "Fáze 1:",
  "electrical_grid.common.power.phase_2": "Fáze 2:",
  "electrical_grid.common.power.phase_3": "Fáze 3:",
  "electrical_grid.common.power_today": "Dnešný odber zo siete:",
  "electrical_grid.common.power_year": "Ročný odber zo siete:",
  "electrical_grid.common.total_consumption": "Celkový odber zo siete",
  "electrical_grid.statistics": "Štatistiky nákupu",
  "electrical_grid.statistics_overflow": "Štatistiky pretoku",
  "electrical_grid.status": "Stav distribučnej siete",
  "ems.activePower": "Činný výkon",
  "ems.apparentPower": "Zdanlivý výkon",
  "ems.details": "Parametre meniča",
  "ems.inverter": "Menič",
  "ems.inverter.mode.backup": "Backup",
  "ems.inverter.mode.feedIn": "Feed-in",
  "ems.inverter.mode.manual": "Manual",
  "ems.inverter.mode.peakShaving": "Peak Shaving",
  "ems.inverter.mode.selfUse": "Self use",
  "ems.inverter.name": "Názov striedača",
  "ems.inverter.name.aelio": "X3-AELIO",
  "ems.inverter.name.notConnected": "Nepripojené",
  "ems.inverter.name.trene100k": "X3-TRENE-100K",
  "ems.inverter.name.trene100ki": "X3-TRENE-100KI",
  "ems.inverter.name.trene125k": "X3-TRENE-125K",
  "ems.inverter.name.unknown": "Neznámy model",
  "ems.mode": "Režim EMS",
  "ems.power.index": "Výkon string {index}",
  "ems.power.total": "Celkový výkon",
  "ems.powerFactor": "Účiník",
  "ems.reactivePower": "Jalový výkon",
  "emsPro.inverter.name.aelio": "X3-AELIO",
  "emsPro.inverter.name.notConnected": "Nepripojené",
  "emsPro.inverter.name.trene1": "X3-TRENE-1",
  "emsPro.inverter.name.trene100k": "X3-TRENE-100K",
  "emsPro.inverter.name.trene125k": "X3-TRENE-125K",
  "emsPro.inverter.name.x3forth": "X3-FORTH",
  "emsPro.inverter.name.x3forthplus": "X3-FORTH+",
  "emsPro.inverter.name.x3grand": "X3-GRAND",
  "emsPro.inverter.name.x3mgag2": "X3-MGA G2",
  "emsPro.inverter.name.x3prog2": "X3-PRO G2",
  "emsService.basicSettings": "Základné nastavenia",
  "emsService.direction.disabled": "Zakázané",
  "emsService.direction.read": "Čítanie",
  "emsService.direction.write": "Zápis",
  "emsService.distributionMetrics": "Distribučné pokyny",
  "emsService.distributionMetrics.diMapping": "Mapovanie vstupov",
  "emsService.distributionMetrics.enabled": "Povolené čítanie distribučných pokynov",
  "emsService.distributionMetrics.source": "Zdroj distribučných pokynov",
  "emsService.distributionMetrics.source.digitalInputs": "Digitálne vstupy",
  "emsService.distributionMetrics.source.plc": "Externé PLC",
  "emsService.enabled": "PLC povolený",
  "emsService.energyMeters": "Elektromery",
  "emsService.energyMeters.add": "Pridať nový elektromer",
  "emsService.energyMeters.addButton": "Pridať",
  "emsService.energyMeters.azRouter": "AZ router",
  "emsService.energyMeters.azRouter.empty": "Žiadne AZ routery",
  "emsService.energyMeters.empty": "Nie sú nakonfigurované žiadne elektromery.",
  "emsService.energyMeters.newMeter": "Názov",
  "emsService.energyMeters.plcMetric": "PLC metrika",
  "emsService.energyMeters.plcMetric.grid": "Sieť",
  "emsService.energyMeters.plcMetric.kgj": "KGJ",
  "emsService.energyMeters.plcMetric.pv": "FVE",
  "emsService.energyMeters.shellyId": "Shelly ID",
  "emsService.energyMeters.source": "Zdroj",
  "emsService.energyMeters.source.azRouter": "AZ router",
  "emsService.energyMeters.source.plc": "PLC",
  "emsService.energyMeters.source.shelly": "Shelly",
  "emsService.gridMetrics": "Sieťové metriky",
  "emsService.gridMetrics.enabled": "Povolené čítanie päty objektu",
  "emsService.ipAddress": "IP adresa",
  "emsService.kgjMetrics": "Metriky KGJ",
  "emsService.kgjMetrics.enabled": "Povolené čítanie z KGJ",
  "emsService.metricsDirection": "Smer",
  "emsService.metricsEnabled": "Povolené",
  "emsService.mqttBroker": "MQTT Broker (Shellies)",
  "emsService.mqttBrokerEnabled": "MQTT Broker povolený",
  "emsService.mqttBrokerStatus": "Stav MQTT Brokeru",
  "emsService.notAvailable": "Funkcia EMS nie je dostupná",
  "emsService.password": "Heslo",
  "emsService.plcStatus": "Stav PLC komunikácie",
  "emsService.pollInterval": "Interval dotazovania (ms)",
  "emsService.pvMetrics": "PV metriky",
  "emsService.pvMetrics.enabled": "Povolené čítanie z FVE",
  "emsService.pvMetrics.meterId": "Elektromer",
  "emsService.pvMetrics.meterSource": "Zdroj dát",
  "emsService.pvMetrics.meterSource.meter": "Elektromer",
  "emsService.pvMetrics.meterSource.plc": "PLC",
  "emsService.shelliesList": "Pripojené Shelly zariadenia",
  "emsService.username": "Používateľské meno",
  "ems_service.link": "EMS služba",
  "ems_service.title": "EMS služba",
  "enerco.ean": "EAN",
  "enerco.enabled": "Integrácia zapnutá",
  "enerco.prediction.disabled": "Integrácia je vypnutá.",
  "enerco.prediction.title": "Predikcia",
  "enerco.title": "Enerco",
  "energomachine.business_flexibility.title": "Obchodná flexibilita",
  "energomachine.connected": "Stav",
  "energomachine.enabled": "Integrácia zapnutá",
  "energomachine.last_messages": "Posledné správy",
  "energomachine.last_messages.date": "Čas",
  "energomachine.last_messages.payload": "Zpráva",
  "energomachine.last_messages.topic": "Topic",
  "energomachine.title": "Energomachine",
  "energyMeters.actualPower": "Aktuálny výkon",
  "energyMeters.general": "Obecné informácie",
  "energyMeters.meter": "Elektromer",
  "energyMeters.notConfigured": "Elektromery nie sú nakonfigurované. Pre nastavenie prejdite do servisného menu.",
  "energyMeters.phase1": "Fáza 1:",
  "energyMeters.phase2": "Fáza 2:",
  "energyMeters.phase3": "Fáza 3:",
  "energyMeters.statistics": "Štatistiky",
  "energyMeters.todayEnergy": "Dnešný odber:",
  "energyMeters.totalEnergy": "Celkový odber",
  "energyMeters.yearEnergy": "Ročný odber:",
  "error": "Chyba pri načítavaní reportu.",
  "expertService.HP": "Tepelné čerpadlo",
  "expertService.HP.CntComErr": "Počítadlo chybných správ",
  "expertService.HP.CntComOk": "Počítadlo platných správ",
  "expertService.HP.IpAdr": "IP adresa tepelného čerpadla",
  "expertService.HP.maxTempHW": "Maximálna teplota teplej vody pre TČ",
  "expertService.HP.maxTempHW.subtitle": "Súčet flexibilnej + nastavenej teploty",
  "expertService.HW": "Bojler",
  "expertService.HW.HwBatteryPriority": "Percento nabitia, od ktorého má vždy prioritu bojler",
  "expertService.HW.HwErrEnabled": "Vyhodnocovať dostupnosť bojlera",
  "expertService.HW.HwResetErrorTime": "Oneskorenie pre reset chyby termostatu",
  "expertService.HW.HwResetErrorTime.subtitle": "Čas v minútach, po ktorom sa chyba termostatu resetuje a opäť sa spustí ohrev vody",
  "expertService.HW.LegionellaLastTime": "Posledné dosiahnutie teploty legionely",
  "expertService.HW.TempId": "ID teplotného čidla",
  "expertService.HW.control": "Typ riadenia bojlera",
  "expertService.HW.control.onoff": "On/Off",
  "expertService.HW.control.proportional": "Plynulé",
  "expertService.HW.hysterezis": "Hystereza bojlera",
  "expertService.HW.hysterezis.subtitle": "Hystereza je len pre bežný ohrev",
  "expertService.HW.maxPower": "Maximálny výkon bojlera v percentách",
  "expertService.HW.maxPower.subtitle": "Toto nastavenie je len pre plné riadenie bojlera a obmedzuje maximálny výkon hornej panelky v percentách.",
  "expertService.HW.offset": "Offset na fázu [W]",
  "expertService.HW.offset.disabled-overflow": "Offset pre riadenie bojlera so zakázaným pretokom na fázu [W]",
  "expertService.HW.offset.disabled-overflow.subtitle": "Vyššie číslo umožní bojleru odoberať viac energie zo siete pri obmedzenom striedači",
  "expertService.HW.offset.enabled-overflow": "Offset pre riadenie bojlera s povoleným pretokom na fázu [W]",
  "expertService.HW.offset.enabled-overflow.subtitle": "Vyššie číslo umožní bojleru odoberať viac energie zo siete.",
  "expertService.HW.offset.ongrid": "Offset pre riadenie bojlera pre sieťové elektrárne [W]",
  "expertService.HW.offset.ongrid.subtitle": "Vyššie číslo umožní bojleru odoberať viac energie zo siete.",
  "expertService.PV": "Fotovoltaika",
  "expertService.PV.BatteryPowerPercent": "Výkon nabíjania batérie v percentách",
  "expertService.PV.CntComErr": "Počítadlo chybných správ",
  "expertService.PV.CntComOk": "Počítadlo platných správ",
  "expertService.PV.ControlMeteringMode": "Spôsob riadenia prebytkov",
  "expertService.PV.ControlMeteringMode.perPhase": "Fázové",
  "expertService.PV.ControlMeteringMode.subtitle": "Fázové riadenie počíta prebytok pre riadenie technológií z jednotlivých fáz. Súčtové riadenie pracuje so súčtom všetkých fáz.",
  "expertService.PV.ControlMeteringMode.sum": "Súčtové",
  "expertService.PV.ExternalPv": "Externá FVE pripojená cez SOLAX Meter 2",
  "expertService.PV.ExternalPvSofar": "Externá FVE pripojená cez SOFAR Meter 2",
  "expertService.PV.IpAdr": "IP adresa striedača",
  "expertService.PV.MeteringMode": "Spôsob merania distribúcie",
  "expertService.PV.MeteringMode.perPhase": "Fázové",
  "expertService.PV.MeteringMode.subtitle": "Fázové meranie počíta nákup aj pretok na každej fáze zvlášť. Súčtové meranie pracuje s výslednou bilanciou všetkých fáz.",
  "expertService.PV.MeteringMode.sum": "Súčtové",
  "expertService.PV.PowerControlType": "Typ riadenia výkonu sieťových striedačov",
  "expertService.PV.PowerControlType.fixed": "Fixné",
  "expertService.PV.PowerControlType.proportional": "Plynulé",
  "expertService.PV.StringNumber": "Počet stringov striedača",
  "expertService.PV.StringNumber.subtitle": "Počet stringov striedača zobrazovaný v aplikácii na záložke FVE",
  "expertService.PV.Versions": "Verzia",
  "expertService.SP": "Spot",
  "expertService.SP.HwCoefficient": "Koeficient odhadu energie do bojlera",
  "expertService.SP.HwCoefficient.subtitle": "Koeficient odhadu množstva energie na nabitie bojlera.",
  "expertService.SP.batteryCoefficient": "Koeficient odhadu času nabíjania batérie",
  "expertService.SP.batteryCoefficient.subtitle": "Koeficient odhadu času na nabitie batérie",
  "expertService.SP.minDifferenceBatterychargeFromGrid": "Minimálne odhadované zvýšenie SOC pre vyčkávanie batérie na FVE",
  "expertService.SP.minDifferenceBatterychargeFromGrid.subtitle": "Ak je odhad nabitia batérie pod touto hodnotou, môže dôjsť k nabitiu batérie zo siete.",
  "expertService.WB": "Wallbox",
  "expertService.WB.CntComErr": "Počítadlo chybných správ",
  "expertService.WB.CntComOk": "Počítadlo platných správ",
  "expertService.WB.IpAdr": "IP adresa wallboxu",
  "expertService.general": "Obecné nastavenie",
  "expertService.general.largeInstallation": "Veľká instalácia",
  "expertService.general.largeInstallation.subtitle": "Rozšíri rozsahy hodnôt pre veľké instalácie",
  "expertService.password": "Prístup do servisu",
  "expertService.password.label": "Heslo",
  "expert_service.app_messages": "Zprávy",
  "expert_service.audit_log": "Audit log",
  "expert_service.error_list": "Seznam chyb",
  "expert_service.link": "Expert Service",
  "expert_service.network": "Sieť",
  "expert_service.network.button": "Prejsť do nastavenia siete",
  "expert_service.network.link": "Sieť",
  "expert_service.reports": "Reporty",
  "expert_service.stats": "Statistiky",
  "expert_service.title": "Service",
  "expert_service.xyz": "Servis",
  "header.title": "Domovská stránka",
  "header.title.app_messages": "Zprávy",
  "header.title.audit_log": "Audit Log",
  "header.title.boiler": "Bojler",
  "header.title.cloud_plugs": "Zásuvky",
  "header.title.dev": "Nastavenie siete",
  "header.title.dev.app_messages": "Notifikace",
  "header.title.dev.az_routers": "AZ routery",
  "header.title.dev.bez_dodavatele": "bezDodavatele",
  "header.title.dev.cloud_plugs": "Cloudové zásuvky",
  "header.title.dev.delta_green": "Delta Green",
  "header.title.dev.electree": "Electree",
  "header.title.dev.enerco": "Enerco",
  "header.title.dev.energomachine": "Energomachine",
  "header.title.dev.inverter_config": "Konfigurácia striedačov",
  "header.title.dev.mqtt_broker": "MQTT Broker",
  "header.title.dev.mqtt_cloud": "MQTT Cloud",
  "header.title.dev.pre_flexibility": "PRE Flexibilita",
  "header.title.dev.scripts": "Scripty",
  "header.title.dev.shellies": "Shellies",
  "header.title.dev.status_log": "Status log",
  "header.title.dev.subscriptions": "Predplatné",
  "header.title.dev_homepage": "Vývojové menu",
  "header.title.ems": "EMS",
  "header.title.ems_service": "EMS Service",
  "header.title.energyMeters": "Elektromery",
  "header.title.expert_service": "Expert služba",
  "header.title.expert_service.network": "Nastavenie siete",
  "header.title.grid": "Distribučná sieť",
  "header.title.heat_pump": "Tepelné čerpadlo",
  "header.title.photovoltaics": "Fotovoltaika",
  "header.title.plug": "Zásuvka",
  "header.title.relay": "Relé",
  "header.title.reports": "Reporty",
  "header.title.rfid_cards": "RFID kárty",
  "header.title.settings": "Nastavenie",
  "header.title.spot": "Spot",
  "header.title.statistics": "Statistiky",
  "header.title.thermostat": "Termostat",
  "header.title.wallbox": "Wallbox",
  "header.title.wallbox_list": "Wallboxy",
  "header.title.wind": "Veterná elektrárna",
  "heat_pump.HW": "Ohrev teplej vody",
  "heat_pump.HW.actual_temp": "Aktuálna teplota nádrže",
  "heat_pump.HW.flexitemp": "Flexibilná teplota",
  "heat_pump.HW.flexitemp.subtitle": "Teplota, o ktorú je možné predohriať teplú vodu",
  "heat_pump.HW.hysteresis": "Hystereza ohrevu teplej vody",
  "heat_pump.HW.on": "Ohrev teplej vody",
  "heat_pump.HW.temp": "Požadovaná teplota nádrže",
  "heat_pump.acond": "Acond",
  "heat_pump.blocked": "Blokácia kompresora",
  "heat_pump.blocked.min_soc": "Blokácia kompresora pri nedostupnej sieti",
  "heat_pump.blocked.min_soc_utility": "Blokácia kompresora pri dostupnej sieti",
  "heat_pump.blocked.subtitle": "Nabitie batérie, od ktorého dôjde k blokácii kompresoru pri dostupnej sieti",
  "heat_pump.common": "Všeobecné informácie",
  "heat_pump.common.power": "Aktuálny odber",
  "heat_pump.common.power_today": "Dnešná spotreba:",
  "heat_pump.common.power_year": "Ročná spotreba:",
  "heat_pump.common.temp": "Výstupná teplota tepelného čerpadla",
  "heat_pump.common.total": "Celková spotreba",
  "heat_pump.ecoone": "Ecoone",
  "heat_pump.flexi": "Flexibilita energie",
  "heat_pump.flexi.flexi_on": "Režim flexibility",
  "heat_pump.flexi.flexi_on.subtitle": "Režim aktivuje predohrev z prebytočnej energie",
  "heat_pump.flexi.pvstability": "Potenciál aktivácie kompresora",
  "heat_pump.flexi_sp": "Flexibilita spot",
  "heat_pump.flexi_sp.flexi_increase_on": "Zvýšenie spotreby",
  "heat_pump.flexi_sp.flexi_increase_on.subtitle": "Režim umožní zvýšenie spotreby pri nízkej cene energie",
  "heat_pump.flexi_sp.flexi_reduce_on": "Odloženie spotreby",
  "heat_pump.flexi_sp.flexi_reduce_on.subtitle": "Režim umožní odloženie spotreby pri vysokej cene energie",
  "heat_pump.nibe": "Nibe",
  "heat_pump.room": "Vykurovanie",
  "heat_pump.room.equithermalCorrection": "Posun vykurovacej krivky",
  "heat_pump.room.flexitemp": "Flexibilná teplota",
  "heat_pump.room.flexitemp.subtitle": "Teplota, o ktorú je možné predohriať alebo predchladiť dom",
  "heat_pump.room.on": "Vykurovanie",
  "heat_pump.room.tem": "Požadovaná teplota",
  "heat_pump.room.temp": "Aktuálna teplota miestnosti",
  "heat_pump.room.tempmax": "Požadovaná teplota komfort",
  "heat_pump.room.tempmin": "Požadovaná teplota útlum",
  "heat_pump.room_cool.on": "Chladenie",
  "heat_pump.status": "Režim tepelka",
  "heat_pump_wizard.cancel": "Zrušiť",
  "heat_pump_wizard.ip_address.alert": "Uistite sa prosím, že IP adresa tepelného čerpadla nebude meniť (napr. keď TČ používa adresu z DHCP).",
  "heat_pump_wizard.ip_address.input": "IP adresa tepelného čerpadla",
  "heat_pump_wizard.open": "Nastaviť typ TČ",
  "heat_pump_wizard.save": "Uložiť",
  "heat_pump_wizard.title": "Nastavenie tepelného čerpadla",
  "heatpump.statistics": "Statistiky",
  "heatpump.status": "Režim tepelka",
  "home.premium.banner.inactive.subtitle": "Infigy Plus prináša detailnejšie grafy, mesačné reporty, notifikácie a mnoho ďalšieho.",
  "home.premium.banner.inactive.title": "Chcete ešte lepší prehľad?",
  "homepage.actual.battery": "Stav batérie",
  "homepage.actual.boiler": "Bojler",
  "homepage.actual.outdoor_temperature": "Vonkajšia teplota",
  "homepage.actual.thermostat": "Thermostat",
  "homepage.actual.title": "",
  "homepage.animation": "Aktuálne",
  "homepage.statuses.title": "Režimy aktívnych komponentov",
  "homepage.statuses.tooltip": "Režimy aktívnych komponentov",
  "homepage.today.consumed": "Spotreba domu",
  "homepage.today.consumed_WB": "Wallbox",
  "homepage.today.consumed_from_grid": "Spotreba zo siete",
  "homepage.today.consumed_hp": "Tepelné čerpadlo",
  "homepage.today.consumed_hw": "Teplá voda",
  "homepage.today.overflow": "Pretok do siete",
  "homepage.today.photovoltaics": "Výroba FVE",
  "homepage.today.title": "Denná štatistika",
  "homepage.today.wind": "Výroba veterné elektrárne",
  "hp.status.compressor_blocked": "Blokácia kompresora, nízky stav batérie",
  "hp.status.cooling": "Chladenie",
  "hp.status.heating": "Vykurovanie",
  "hp.status.hot_water": "Ohrev teplej vody",
  "hp.status.inactive": "Neaktívny",
  "hp.status.not_connected": "Nemožno nadviazať spojenie",
  "hp.status.not_licensed": "Tepelné čerpadlo nie je licencované",
  "hp.status.pool": "Ohrev bazéna",
  "hp.sub_status.consumption_postpone": "pri znížení spotreby",
  "hp.sub_status.consumption_rise": "pri zvýšení spotreby",
  "hp.sub_status.consumption_with_flexibility": "s flexibilitou",
  "hp.sub_status.nibe_not_writable": "- do NIBE nie je možné zapisovať",
  "hp.sub_status.none": "",
  "initial_wizard.banner.button": "Spustiť sprievodca",
  "initial_wizard.banner.hide.confirm": "Naozaj chcete skrýt sprievodca?",
  "initial_wizard.banner.hide.confirm.description": "Sprievodcu môžete kedykoľvek znovu spustiť v nastavení aplikácie.",
  "initial_wizard.banner.hide.show_more": "Spustiť sprievodca",
  "initial_wizard.banner.hide.yes": "Skrýt",
  "initial_wizard.banner.subtitle": "Sprievodca vám pomôže nastaviť základné parametre vášho systému.",
  "initial_wizard.banner.title": "Dokončite počiatočné nastavenie",
  "initial_wizard.banner.title.completed": "Prejsť počiatočné nastavenie",
  "initial_wizard.dialog.finish": "Dokončit",
  "initial_wizard.dialog.next": "Další",
  "initial_wizard.dialog.prev": "Späť",
  "initial_wizard.dialog.step": "Krok {current} z {total}",
  "initial_wizard.dialog.title": "Sprievodca počiatočným nastavením",
  "initial_wizard.step1.description.active": "Váš prístup do servisu je už aktívny. Môžete pokračovat na další krok.",
  "initial_wizard.step1.password_info": "Každá firma má vlastné prístupové heslo do servisného menu. Heslo ste obdržali v e-mailovej komunikácii. Môžete si jej také kdykoliv zobrazit v app.infigy.cz v partnerskej sekcii.",
  "initial_wizard.step1.title": "Prístup do servisu",
  "initial_wizard.step1.welcome": "Vitajte v úvodnom nastavení Infigy. Prevedieme vás základnou konfiguráciou vášho systému. Detailnejšie nastavenie potom nájdete v servisnom menu.",
  "initial_wizard.step10.title": "Nastavenie wallboxu",
  "initial_wizard.step11.description": "Prešli ste základné nastavenie Infigy. Všetky parametre možno upraviť v servisnom menu.",
  "initial_wizard.step11.service_menu.subtitle": "Nastavenie -> úplne dole -> Prístup do servisu",
  "initial_wizard.step11.service_menu.title": "Servisné menu",
  "initial_wizard.step11.title": "Hotovo",
  "initial_wizard.step2.title": "Aktualizácia aplikácie",
  "initial_wizard.step3.title": "Inštalácia",
  "initial_wizard.step4.title": "Nastavenie hlavného ističa",
  "initial_wizard.step5.title": "Pripojenie striedača",
  "initial_wizard.step6.title": "Parametre striedača",
  "initial_wizard.step7.description": "Ak je obmedzený pretok do siete, dôjde k preneseniu nastavenia do striedača. Obmedzovanie pretokov zabezpečuje striedač. Zápis a zmenu hodnoty však riadi Infigy podľa zadanej hodnoty v tomto poli. Neupravujte teda obmedzenie pretoku v striedači. Pri prvom nastavení si zapísanú hodnotu skontrolujte v striedači, či sa vám správne premietla z Infigy do striedača.",
  "initial_wizard.step7.title": "Obmedzenie pretoku",
  "initial_wizard.step8.title": "Nastavenie bojlera",
  "initial_wizard.step9.title": "Nastavenie spotového obchodovania",
  "initial_wizard.step_app_update.description": "V čase, keď bolo Infigy na ceste k vám, sme mohli vydať nové verzie aplikácie. Odporúčame pred nastavením jednotku aktualizovať. Ak ale napríklad nie je dostupný internet, môžete aktualizáciu preskočiť a vykonať ju neskôr v servisnom menu alebo v portáli.",
  "inverter.3mar_plc": "3Mar PLC",
  "inverter.az_router": "AzRouter elektromer",
  "inverter.control.mode": "Riadenie meniča",
  "inverter.control.mode.chargingFromGrid": "Nabíjanie batérie zo siete",
  "inverter.control.mode.dischargingToGrid": "Vybíjanie batérie do siete",
  "inverter.control.mode.noneControl": "Bez riadenia",
  "inverter.control.mode.stopCharging": "Zastavenie nabíjania",
  "inverter.control.mode.stopDischarging": "Zastavenie vybíjania",
  "inverter.control.mode.stopOverflow": "Zastavenie pretokov",
  "inverter.des_battery_container": "DES - kontajnerové úložisko",
  "inverter.deye": "Deye LV",
  "inverter.deye_hv": "Deye HV",
  "inverter.fronius": "Fronius SYMO GEN24",
  "inverter.fronius_grid": "Fronius SYMO sieťový",
  "inverter.fronius_verto": "Fronius Verto",
  "inverter.good_we": "GoodWe",
  "inverter.good_we_grid_next": "GoodWe sieťový",
  "inverter.good_we_next": "GoodWe",
  "inverter.goodwe_grid": "Goodwe sieťový",
  "inverter.hes": "HES - batériové úložisko",
  "inverter.next": "Viac striedačov",
  "inverter.none": "Žiadny",
  "inverter.sermatec": "Sermatec",
  "inverter.shellies": "Shellies",
  "inverter.shellies_external": "Shellies External",
  "inverter.sma_grid": "SMA sieťový",
  "inverter.sofar_solar": "Sofarsolar",
  "inverter.sofar_solar_rs485": "SofarSolar RS485",
  "inverter.solar_edge_grid": "SolarEdge síťový",
  "inverter.solax": "Solax",
  "inverter.solax_ems1000": "Solax EMS1000",
  "inverter.solax_ems1000pro": "Solax EMS1000PRO",
  "inverter.solax_grid": "Solax síťový",
  "inverter.solax_mega_grid": "Solax MEGA/FORTH síťový",
  "inverter.solax_mic_grid": "Solax MIC síťový",
  "inverter.solax_next": "SolaxNext",
  "inverter.solinteg": "Solinteg",
  "inverter.victron": "Victron",
  "inverter.wattsonic": "Wattsonic",
  "inverter_wizard.cancel": "Zrušiť",
  "inverter_wizard.custom_device_ip_address.alert": "Uistite sa prosím, že sa IP adresa striedača nebude meniť (napr. keď striedač využíva adresu z DHCP).",
  "inverter_wizard.custom_device_ip_address.input": "IP adresa striedača",
  "inverter_wizard.multiple_inverters.alert": "Pre nastavenie viacerých striedačov prosím kontaktujte linku podpory. Kontakt nájdete v technickej wiki Infigy.",
  "inverter_wizard.multiple_inverters.label": "Viac striedačov",
  "inverter_wizard.multiple_inverters_or_ems.alert": "Váš systém už má nastavenie pre viac striedačov alebo EMS. Tento sprievodca je určený len pre nastavenie jedného striedača. Pre zmenu nastavenia striedačov alebo EMS prosím kontaktujte podporu.",
  "inverter_wizard.nominal_power": "Nominálny výkon striedača",
  "inverter_wizard.nominal_power.helper": "Rozsah: 1 až 100 kW",
  "inverter_wizard.nominal_power.validation": "Zadajte nominálny výkon striedača v kW.",
  "inverter_wizard.open": "Nájsť striedač",
  "inverter_wizard.save": "Uložiť",
  "inverter_wizard.scan": "Nájsť striedač na sieti",
  "inverter_wizard.scanning": "Hľadám striedač v sieti",
  "inverter_wizard.submit_error": "Nastala chyba pri ukladaní nastavenia striedača. Skúste to prosím znova.",
  "inverter_wizard.title": "Sprievodca pripojením striedača",
  "layout.disconnected": "Odpojené",
  "layout.pigpio_init_error_dialog.description": "Aplikácia Infigy na zariadení nebežala správne. Skúste prosím zariadenie reštartovať a ak problém pretrváva, kontaktujte podporu.",
  "layout.pigpio_init_error_dialog.title": "Chyba pri spustení aplikácie",
  "level.thermostat.cooling": "Chladenie",
  "level.thermostat.deactivated": "Neaktívny",
  "level.thermostat.heating": "Vykurovanie",
  "level.thermostat.standby": "Standby",
  "level.thermostat.tempErr": "Chyba teploty",
  "level.thermostatFlexibility.increasePv": "Flexibilita využita na zvýšenie teploty podľa fotovoltaiky",
  "level.thermostatFlexibility.increaseSpot": "Flexibilita využita na zvýšenie teploty podľa SPOTU",
  "level.thermostatFlexibility.normal": "Normální",
  "level.thermostatFlexibility.reductionSpot": "Flexibilita využita na zníženie teploty podľa SPOTU",
  "mqtt_broker.connected_clients.title": "Clients",
  "mqtt_broker.enabled": "Zapnuto",
  "mqtt_broker.running": "Stav",
  "mqtt_broker.title": "MQTT Broker",
  "mqtt_cloud.connected": "Stav",
  "mqtt_cloud.connected.offline": "Offline",
  "mqtt_cloud.connected.online": "Online",
  "mqtt_cloud.enabled": "Integrácia zapnutá",
  "mqtt_cloud.title": "MQTT Cloud",
  "nav.app_messages": "Zprávy",
  "nav.home": "Domov",
  "nav.logout": "Odhlásiť sa",
  "nav.reports": "Reporty",
  "nav.sec.boiler": "Bojler",
  "nav.sec.cloud_plugs": "Zásuvky",
  "nav.sec.ems": "EMS",
  "nav.sec.energyMeters": "Elektromery",
  "nav.sec.grid": "Sieť",
  "nav.sec.heatpump": "Tepelné čerpadlo",
  "nav.sec.home": "Všeobecné",
  "nav.sec.photovoltaics": "Fotovoltaika",
  "nav.sec.plug": "Zásuvka",
  "nav.sec.relay": "Relé",
  "nav.sec.spot": "Spot",
  "nav.sec.thermostat": "Termostat",
  "nav.sec.wallbox": "Wallbox",
  "nav.sec.wind": "Veterná elektrárna",
  "nav.settings": "Nastavenie",
  "nav.statistics": "Statistiky",
  "network.ethernet_ports": "Ethernet porty",
  "network.ethernet_ports.name": "LAN",
  "network.ethernet_ports.status": "Status",
  "network.ethernet_ports.status.down": "Neaktívny",
  "network.ethernet_ports.status.up": "Aktivní",
  "network.scan.error": "Skenovanie siete zlyhalo",
  "network.summary.address": "IP adresa",
  "network.summary.dhcp_host_exists": "Adresa zafixována na DHCP. Kliknutím odfixovat.",
  "network.summary.error": "Chyba pri načítavaní",
  "network.summary.heat_pump": "Tepelné čerpadlo",
  "network.summary.inverter": "Striedač",
  "network.summary.mac": "MAC",
  "network.summary.name": "Meno",
  "network.summary.no_dhcp_host": "Dynamická adresa na DHCP. Kliknutím zafixovat.",
  "network.summary.not_connected": "Nie je pripojené",
  "network.title": "Všeobecné",
  "network.wan_address": "WAN adresa",
  "network_wan_edit.dialog.address": "IP adresa",
  "network_wan_edit.dialog.close": "Zavrieť",
  "network_wan_edit.dialog.dns": "DNS server",
  "network_wan_edit.dialog.gateway": "Východzí brána",
  "network_wan_edit.dialog.netmask": "Maska siete",
  "network_wan_edit.dialog.save": "Uložiť",
  "network_wan_edit.dialog.title": "Úprava WAN adresy",
  "nmap.empty": "Nic nenalezeno",
  "nmap.error": "Skenovanie zlyhalo",
  "nmap.host": "Adresa",
  "nmap.loading": "Skenujem",
  "nmap.output": "Výstup",
  "nmap.port": "Port",
  "nmap.port.help": "Prázdne = len hľadanie zariadenia",
  "nmap.range.external": "external — sieť zákazníka",
  "nmap.range.internal": "internal — interná sieť Infigy",
  "nmap.result.address": "IP adresa",
  "nmap.result.mac": "MAC adresa",
  "nmap.result.ports": "Porty",
  "nmap.result.scanning": "Skenujeme {target}, môže to chvíľu trvať…",
  "nmap.result.target": "Skenovaný rozsah: {target}",
  "nmap.result.vendor": "Výrobca",
  "nmap.start": "Spustiť",
  "nmap.target": "Adresa alebo rozsah",
  "nmap.target.help": "Pojmenovaná sieť alebo IP / rozsah",
  "nmap.title": "Skenovanie portov",
  "photovoltaics.battery": "Batéria",
  "photovoltaics.battery.battery_charged": "Nabitie batérie",
  "photovoltaics.battery.battery_manual_discharge": "Manuálne vybíjanie batérie",
  "photovoltaics.battery.battery_power": "Výkon batérie",
  "photovoltaics.battery.soc_actual": "Vypočítané minimálne nabitie",
  "photovoltaics.batteryStatus": "Stav BMS",
  "photovoltaics.battery_stop": "Blokovanie batérie",
  "photovoltaics.battery_stop.hdo": "Vybíjanie baterie iba pri nízkom tarife (HDO)",
  "photovoltaics.battery_stop.hp": "Blokovanie baterie pri provádzaní tepelného čerpadla",
  "photovoltaics.battery_stop.hw": "Blokovanie baterie pri provádzaní ohrevu vody",
  "photovoltaics.battery_stop.wb": "Blokovanie baterie pri provádzaní wallboxu",
  "photovoltaics.battery_stop.wb.lock_desc": "Pri zapnutom režime nabíjania wallboxu „Nabíjanie podľa batérie“ nemožno túto blokáciu zapnúť. Po zapnutí blokácie nastavte iný režim nabíjania wallboxu.",
  "photovoltaics.battery_stop.wb.lock_title": "Nastavenie nemožno zmeniť",
  "photovoltaics.common": "Všeobecné informácie",
  "photovoltaics.common.battery_charged": "Nabitie batérie",
  "photovoltaics.common.battery_manual_charge": "Manuálne nabíjanie batérie",
  "photovoltaics.common.battery_manual_charge_soc": "Cieľové nabitie pre manuálne nabíjanie",
  "photovoltaics.common.battery_manual_charge_subtitle": "Manuálne nabíjanie baterie nabije bateriu na cieľovú úroveň nabitia, ak sa nevypne skôr užívateľom.",
  "photovoltaics.common.battery_manual_discharge": "Manuálne vybit batériu",
  "photovoltaics.common.battery_manual_discharge_subtitle": "Manuálne vybíjanie baterie vybije bateriu na minimálnu úroveň nabitia, ak sa nevypne skôr užívateľom.",
  "photovoltaics.common.battery_power": "Výkon batérie",
  "photovoltaics.common.power": "Aktuálny výkon",
  "photovoltaics.common.power_today": "Dnešná výroba:",
  "photovoltaics.common.power_total": "Celková výroba",
  "photovoltaics.common.power_year": "Ročná výroba:",
  "photovoltaics.common.string1": "String 1:",
  "photovoltaics.common.string2": "String 2:",
  "photovoltaics.common.string3": "String 3:",
  "photovoltaics.common.string4": "String 4:",
  "photovoltaics.common.string5": "String 5:",
  "photovoltaics.common.string6": "String 6:",
  "photovoltaics.statistics": "Výkon elektrárne",
  "photovoltaics.statistics.charge": "Nabíjanie batérie",
  "photovoltaics.statistics.discharge": "Vybíjení batérie",
  "photovoltaics.statisticsSoc": "Úroveň nabití batérie",
  "photovoltaics.status": "Režim FVE",
  "ping.address": "Adresa",
  "ping.output": "Výstup",
  "ping.start": "Spustiť",
  "ping.stop": "Zastaviť",
  "ping.title": "Ping",
  "plug.bat": "Riadenie podľa batérie",
  "plug.bat.batterySart": "Zapnúť pri nabití",
  "plug.bat.batterySart.help": "Úroveň nabití batérie, pri ktorom sa zásuvka zapne. Aby k zapnutí došlo, musí dôjsť k prechodu nabití batérie z nastaveného stavu na vyšší stav. Ak je hodnota nastavená na 80%, tak zásuvka sepne pri nabití batérie zo 80% na 81%.",
  "plug.bat.batterySart.subtitle": "Nabitie batérie, pri ktorom sa aktivuje zásuvka",
  "plug.bat.batteryStop": "Vypnúť pri nabití",
  "plug.bat.batteryStop.help": "Úroveň nabití batérie, pri ktorom sa zásuvka vypne. Aby k vypnutí došlo, musí dôjsť k prechodu nabití batérie z nastaveného na nižší stav. Ak je hodnota nastavená na 80%, tak zásuvka vypne pri vybití batérie zo 80% na 79%.",
  "plug.bat.batteryStop.subtitle": "Nabitie batérie, pri ktorom sa vypne zásuvka",
  "plug.bat.help": "Spínanie pri definovanej úrovni nabitia batérie. Možno kombinovať s podmienkou času. Pri kombinácii podmienok sa zásuvka zapne, ak je splnená aspoň jedna z podmienok na zapnutie a vypne, ak je splnená aspoň jedna z podmienok na vypnutie.",
  "plug.bat.on": "Aktivní",
  "plug.main": "Všeobecné informácie",
  "plug.main.consumption": "Aktuálna spotreba",
  "plug.main.power": "Celková spotreba",
  "plug.main.power_today": "Dnešná spotreba:",
  "plug.main.power_year": "Ročná spotreba:",
  "plug.main.stat": "Statistiky",
  "plug.overflow": "Riadenie podľa pretoku",
  "plug.overflow.consumption": "Nastavenie odpovídá spotrebiču s príkonom",
  "plug.overflow.help": "Zapínanie zásuvky pri definovanom pretoku do distribučnej siete. Možno kombinovať s podmienkou času. Pri kombinácii podmienok sa zásuvka zapne, ak je splnená aspoň jedna z podmienok na zapnutie a vypne, ak je splnená aspoň jedna z podmienok na vypnutie.",
  "plug.overflow.on": "Aktivní",
  "plug.overflow.startPower": "Zapnúť pri odberu zo siete",
  "plug.overflow.startPower.help": "Zásuvka sa zapne, ak je pretok v nastavenej výške po definovaný interval oneskorenie. Ak je hodnota nastavená na - 1500W a oneskorenie zapnutí je 5 minut, tak zásuvka sepne pri pretoku do siete vo výške alespoň 1500W po dobu 5 minut.",
  "plug.overflow.startPower.subtitle": "Záporná hodnota je pretok, kladná hodnota je odber",
  "plug.overflow.stopPower": "Vypnúť pri odberu zo siete",
  "plug.overflow.stopPower.help": "Zásuvka sa vypne, ak je odber vyšší než nastavený po definovaný interval oneskorenie. Ak je hodnota nastavená na 100W a oneskorenie vypnutí je 5 minut, tak zásuvka vypne pri odberu zo siete vo výške minimálne 100W po dobu 5 minut.",
  "plug.overflow.stopPower.subtitle": "Záporná hodnota je pretok, kladná hodnota je odber",
  "plug.overflow.time": "Oneskorenie zapnutia a vypnutí",
  "plug.overflow.time.help": "Tento parametr slúži na definíciu oneskorenie zapnutí a vypnutí zásuvky pri definovaných pretokoch/odberoch. Vhodné pre nastavenie priority a elimináciu častého spínání zásuvky. Zadávajte vo formáte HH:MM.",
  "plug.plug": "Zásuvka",
  "plug.spot": "Riadenie podľa spotovej ceny",
  "plug.spot.15m.period": "Perioda spotovej ceny",
  "plug.spot.15m.period.subtitle": "15 minútové intervaly",
  "plug.spot.help": "Spínanie pri definovanej spotovej cene. Možno kombinovať s podmienkou času. Pri kombinácii podmienok sa zásuvka zapne, ak je splnená aspoň jedna z podmienok na zapnutie a vypne, ak je splnená aspoň jedna z podmienok na vypnutie.",
  "plug.spot.on": "Aktívny",
  "plug.spot.period": "Perioda spotovej ceny",
  "plug.spot.period.subtitle": "60 minútové intervaly",
  "plug.spot.price.period": "Časové rozlíšenie zásuvky",
  "plug.spot.spotHi": "Aktivovať pri vysokej cene",
  "plug.spot.spotHi.help": "Zásuvka sa zapne, ak je cena spotu na vysoké úrovni pozri záložku Spot.",
  "plug.spot.spotLow": "Aktivovať pri nízkej cene spotu",
  "plug.spot.spotLow.help": "Zásuvka sa zapne, ak je cena spotu na nízké úrovni pozri záložku Spot.",
  "plug.spot.spotMi": "Aktivovať pri strednej cene",
  "plug.spot.spotMi.help": "Zásuvka sa zapne, ak je cena spotu na strednej úrovni pozri záložku Spot.",
  "plug.spot.spot_above_price": "Aktivovať pri vyššej než nastavenej cene",
  "plug.spot.spot_above_price.help": "Zásuvka sa aktivuje, ak je cena spotu vyššia alebo rovná nastavenej cene spotu.",
  "plug.spot.spot_above_price.subtitle": "Ak je cena spotu vyšší nebo rovna tejto hodnote, dôjde k sepnutiu. Ak je nižší, dôjde k rozepnutiu.",
  "plug.spot.spot_below_price": "Aktivovať pri nižšej než nastavenej cene",
  "plug.spot.spot_below_price.help": "Zásuvka sa aktivuje, ak je cena spotu nižšia alebo rovná nastavenej cene spotu.",
  "plug.spot.spot_below_price.subtitle": "Ak je cena spotu nižší nebo rovna tejto hodnote, dôjde k sepnutiu. Ak je vyšší, dôjde k rozepnutiu.",
  "plug.spot.spot_neg": "Aktivovať pri zákaze pretokov do siete",
  "plug.spot.spot_neg.help": "Zásuvka sa aktivuje, ak je zakázaný pretok do siete pozri plán spotového obchodování.",
  "plug.status": "Režim zásuvky",
  "plug.summary.price": "Cena",
  "plug.summary.price_level": "Hladina ceny",
  "plug.summary.price_level_15m": "Hladina ceny 15m",
  "plug.summary.switch": "Sepnutie zásuvky",
  "plug.summary.time": "Čas",
  "plug.time": "Riadenie podľa času",
  "plug.time.help": "Spínanie pri definovanom čase. Možno kombinovať s ostatnými podmienkami podľa batérie (musí byť nainštalovaná batéria), spotové ceny (musí byť povolené spotové obchodovanie) a pretoku (musí byť povolený pretok do DS). Pri kombinácii podmienok sa zásuvka zapne, ak je splnená aspoň jedna z podmienok na zapnutie a vypne, ak je splnená aspoň jedna z podmienok na vypnutie.",
  "plug.time.on": "Aktívny",
  "plug.time.turn_off": "Vypnúť v čase",
  "plug.time.turn_off.help": "Čas, v ktorom sa zásuvka vypne. Ak je nastavené na 12:00, tak sa zásuvka vypne presne v nastavený čas 12:00.",
  "plug.time.turn_on": "Zapnúť v čase",
  "plug.time.turn_on.help": "Čas, v ktorom sa zásuvka zapne. Ak je nastavené na 12:00, tak sa zásuvka zapne presne v nastavený čas 12:00.",
  "plug.turn_off": "Vypnúť",
  "plug.turn_on": "Zapnúť",
  "pre_flexibility.business_flexibility.title": "Obchodná flexibilita",
  "pre_flexibility.enabled": "Integrácia zapnutá",
  "pre_flexibility.title": "PRE Flexibilita",
  "premium.banner.active.button": "Spravovať predplatné",
  "premium.banner.active.dev_mode": "Predplatné je aktívne pre vývoj",
  "premium.banner.active.subtitle": "Predplatné Infigy Plus je aktívne. Môžete si užívať všetky vychytávky, ktoré sú vďaka nemu v aplikácii navyše.",
  "premium.banner.active.title": "Moje Infigy Plus",
  "premium.banner.hide.confirm": "Naozaj chcete skrýt Infigy Plus?",
  "premium.banner.hide.confirm.description": "Kedykoľvek môžete Infigy Plus znovu preskúmať v nastavení aplikácie.",
  "premium.banner.hide.later": "Pripomenúť neskôr",
  "premium.banner.hide.show_more": "Zjistit více",
  "premium.banner.hide.yes": "Skrýt",
  "premium.banner.inactive.button": "Zjistit více",
  "premium.banner.inactive.subtitle": "Posuňte svoju správu energií na ešte vyššiu úroveň. S Infigy Plus dostanete ďalšie chytré nástroje - detailné grafy, okamžité notifikácie, vylepšený plánovací kalendár, prehľadné reporty a ďalšie.",
  "premium.banner.inactive.title": "Infigy Plus nie je aktívny",
  "premium.dialog.charts.subtitle": "Získajte možnosť sledovať výkon jednotlivých stringov, spotrebu podľa fáz a ďalšie podrobné informácie.",
  "premium.dialog.charts.title": "Detailní grafy",
  "premium.dialog.notifications.subtitle": "Získavajte notifikácie o záporných cenách, nabitej batérii a ďalších udalostiach",
  "premium.dialog.notifications.title": "Notifikace",
  "premium.dialog.other_benefits.subtitle": "Pripravujeme množstvo ďalších benefitov, ktoré budeme postupne uvoľňovať pre predplatiteľov Infigy Plus",
  "premium.dialog.other_benefits.title": "Ďalšie benefity prídu čoskoro",
  "premium.dialog.reports.subtitle": "Detailné mesačné reporty, ktoré vám poskytnú jasný obraz o výrobe, spotrebe a využití energie vo vašej domácnosti. Všetky dôležité údaje máte na jednom mieste - zrozumiteľne, prehľadne a doplnené grafmi.",
  "premium.dialog.reports.title": "Pokročilé reporty",
  "premium.dialog.save": "Predplatiť Infigy Plus",
  "premium.dialog.schedule.subtitle": "Naplánujte si ručne nabíjanie či vybíjanie batérie podľa potreby",
  "premium.dialog.schedule.title": "Vylepšený plánovací kalendár",
  "premium.dialog.spot.subtitle": "Získajte možnosť nahliadnuť do histórie spotových cien a plánov, ktoré Infigy v minulosti pripravilo",
  "premium.dialog.spot.title": "Historie spotových cen",
  "protocol.settings": "Nastavenie",
  "protocol.settings.Licence": "Licence",
  "protocol.settings.distribution": "Distribuce",
  "protocol.test": "Test zariadenia",
  "protocol.test.internet-connect": "Pripojenie k internetu",
  "protocol.test.inverter-connect": "Pripojenie striedača",
  "protocol.test.phase_1": "Test 1. fáze",
  "protocol.test.phase_2": "Test 2. fáze",
  "protocol.test.phase_3": "Test 3. fáze",
  "protocol.test.tester": "Zariadenie otestoval",
  "relay.condition": "Podmínka spínání",
  "relay.main": "Všeobecné informácie",
  "relay.name": "Názov relé",
  "relay.spot.diagram": "Spínanie podľa spotovej ceny",
  "relay.status": "Sepnuto",
  "relay.summary.switch": "Sepnutie relé",
  "relay.title": "Relé",
  "report.avg_day_chart.battery_soc": "Nabitie batérie",
  "report.avg_day_chart.consumption": "Spotreba",
  "report.avg_day_chart.grid": "Distribučná sieť",
  "report.avg_day_chart.pv_production": "Výroba FVE",
  "report.not_generated": "Vytvoriť report kliknutím",
  "report_test.button": "Test",
  "report_test.date": "Mesiac (napr. 2025-09)",
  "report_test.generated": "Report vygenerován",
  "report_test.ok": "OK",
  "report_test.test": "Test",
  "reports.accumulation_increased": "Zvýšenie akumulácie",
  "reports.average_water_temperature": "Priemerná teplota vody",
  "reports.avg_day": "Priemerný deň",
  "reports.battery": "Batéria",
  "reports.boiler": "Bojler",
  "reports.building_consumption": "Spotreba objektu",
  "reports.disclaimer": "Uvedené hodnoty majú len informativný charakter a môžu sa líšiť od oficiálnych odčítaní distribútora.",
  "reports.energy_estimate": "Odhad energií bez riadenia",
  "reports.estimated_water_amount": "Odhadované množství vody",
  "reports.grid_consumption": "Odber zo siete",
  "reports.grid_consumption_hp": "Spotreba zo siete",
  "reports.grid_consumption_hw": "Spotreba zo siete",
  "reports.grid_consumption_wallbox": "Spotreba zo siete",
  "reports.heat_pump": "Tepelné čerpadlo",
  "reports.household_consumption": "Spotreba domácnosti",
  "reports.info": "Všeobecné info",
  "reports.kilometers_driven": "Počet ujetých km",
  "reports.kilometers_driven_from_sun": "Počet ujetých km zo slnka",
  "reports.maximum_power": "Maximálny výkon",
  "reports.monthly_consumption": "Mesačná spotreba",
  "reports.monthly_production": "Mesačná výroba",
  "reports.pv": "Fotovoltaická elektrárna",
  "reports.pv_consumption": "Spotreba z FVE",
  "reports.pv_production": "Výroba FVE",
  "reports.regenerate_report": "Znovu vygenerovat report",
  "reports.regenerate_report_confirm_title": "Znovu vygenerovat report?",
  "reports.rfid_cards": "RFID kárty",
  "reports.self_consumption": "Vlastní využití energie",
  "reports.self_sufficiency": "Sebestačnosť",
  "reports.self_sufficient_days": "Počet sebestačných dní",
  "reports.share.description": "Vybraný snímok môžete zdieľať s ostatnými.",
  "reports.share.share": "Sdílet report",
  "reports.share.title": "Sdílet report",
  "reports.share_report": "Sdílet report",
  "reports.sold_to_distribution_grid": "Prodáno do distribučnej siete",
  "reports.stored_energy_from_grid": "Uložená energie zo siete",
  "reports.stored_energy_from_pv": "Uložená energie z FVE",
  "reports.stored_energy_to_battery": "Uložená energie do batérie",
  "reports.stored_energy_to_boiler": "Uložená energie do bojleru",
  "reports.stored_energy_to_heat_pump": "Uložená energie do TČ",
  "reports.stored_energy_to_wallbox": "Uložená energie do wallboxu",
  "reports.total_overflow_to_grid": "Celkový pretok do siete",
  "reports.total_purchase_from_grid": "Celkový nákup zo siete",
  "reports.total_with_control": "Celkom s riadením",
  "reports.total_without_control": "Celkom bez riadenia",
  "reports.updated_at": "Vygenerováno {date}",
  "reports.wallbox": "Wallbox",
  "rfid_cards.col.consumption": "Spotreba",
  "rfid_cards.col.created_at": "Pridané",
  "rfid_cards.col.id": "ID kárty",
  "rfid_cards.col.name": "Název",
  "rfid_cards.export": "Exportovať CSV",
  "rfid_cards.from": "Od",
  "rfid_cards.no_cards": "Žiadne kárty neboli pridané.",
  "rfid_cards.title": "RFID kárty",
  "rfid_cards.to": "Do",
  "save": "Uložiť",
  "schedules.add": "Pridať plán",
  "schedules.battery_charge": "Nabíjanie batérie",
  "schedules.battery_discharge": "Vybíjanie batérie",
  "schedules.charging_current": "Nabíjací prúd: {chargingCurrent} A",
  "schedules.description": "Naplánujte si vybitie alebo nabitie batérie podľa potreby.",
  "schedules.dialog.title": "Vytvoriť plán",
  "schedules.dialog.title.ev": "Vytvoriť plán nabíjania",
  "schedules.ev_charging": "Nabíjanie elektromobilu",
  "schedules.form.action": "Akcia",
  "schedules.form.battery_charge": "Nabítí batérie",
  "schedules.form.battery_discharge": "Vybitie batérie",
  "schedules.form.charging-current": "Nastavenie nabíjacieho prúdu",
  "schedules.form.charging-current.auto": "Predvolené",
  "schedules.form.create": "Vytvoriť",
  "schedules.form.duration": "Dĺžka",
  "schedules.form.duration.120min": "2 hodina",
  "schedules.form.duration.180min": "3 hodiny",
  "schedules.form.duration.240min": "4 hodiny",
  "schedules.form.duration.300min": "5 hodin",
  "schedules.form.duration.360min": "6 hodin",
  "schedules.form.duration.60min": "1 hodina",
  "schedules.form.ev_charging": "Nabíjanie elektromobilu",
  "schedules.form.frequency": "Frekvencia",
  "schedules.form.frequency.daily": "Denne",
  "schedules.form.frequency.monthly": "Mesiacne",
  "schedules.form.frequency.weekly": "Týždenne",
  "schedules.form.interval.biweekly": "Každé 2 týždne",
  "schedules.form.preview.hide": "Skryť náhľad",
  "schedules.form.preview.show": "Zobraziť plánované výskyty",
  "schedules.form.preview.title": "Plánované spustenia ({count} nasledujúcich)",
  "schedules.form.recurring": "Opakovanie",
  "schedules.form.target-soc": "Cilové SOC (voliteľné)",
  "schedules.form.until": "Opakovať do (voliteľné)",
  "schedules.form.when": "Kdy",
  "schedules.loading.error": "Chyba pri načítavaní plánov",
  "schedules.missed": "Neprebehlo",
  "schedules.no_plans_found": "Žiadne plány neboli nájdené.",
  "schedules.processed": "Prebehlo",
  "schedules.remove.confirm": "Naozaj chcete plán vymazať?",
  "schedules.remove.no": "Zrušiť",
  "schedules.remove.recurring.instance": "Vymazať len tento výskyt",
  "schedules.remove.recurring.series": "Vymazať celú sériu",
  "schedules.remove.recurring.title": "Vymazať opakovaný plán",
  "schedules.remove.yes": "Vymazať",
  "schedules.running": "Prebieha",
  "schedules.scheduled": "Naplanované",
  "schedules.show_processed": "Zobraziť prebehnuté",
  "schedules.target_soc": "Cílové SOC: {targetSoc, number, percent}",
  "schedules.title": "Plánovač",
  "scripts.add": "Vytvoriť",
  "scripts.delete": "Vymazať",
  "scripts.edit": "Upraviť",
  "scripts.loading_error": "Chyba pri načítavaní skriptov",
  "scripts.title": "Skripty",
  "settings.PV.NominalInverterPower": "Nominálny výkon striedača",
  "settings.PV.NominalInverterPower.help": "Pre Solinteg, Wattsonic a Deye je toto dôležité pre správny výpočet pretokov do siete.",
  "settings.PV.NominalInverterPower.subtitle": "Nominálny výkon striedača v kW, dôležitý pre výpočet % pretokov do siete.",
  "settings.PV.StringNumber": "Počet stringov striedače",
  "settings.PV.StringNumber.subtitle": "Počet stringov striedače zobrazovaný v aplikaci na záložke FVE",
  "settings.app_update": "Verzia aplikácie",
  "settings.app_update.check_button": "Zkontrolovat aktualizace",
  "settings.app_update.confirm.cancel": "Zrušiť",
  "settings.app_update.confirm.confirm": "Aktualizovat",
  "settings.app_update.confirm.description": "Aktualizácia môže trvať niekoľko minút. Počas aktualizácie bude aplikácia nedostupná a následne sa automaticky reštartuje.",
  "settings.app_update.confirm.title": "Spustiť aktualizaci?",
  "settings.app_update.error.no_internet": "Zkontrolujte síťové pripojenia",
  "settings.app_update.in_progress": "Aktualizácia prebieha",
  "settings.app_update.request_button": "Aktualizace je k dispozici",
  "settings.app_update.requested": "Aktualizace byla vyžádána",
  "settings.app_update.subtitle": "Zkontrolujte dostupnost nových verzí",
  "settings.app_update.title": "Aktualizácia aplikácie",
  "settings.app_update.up_to_date": "Aplikácia je aktuálna",
  "settings.boiler": "Bojler",
  "settings.boiler.3phase": "Trojfázová patrona",
  "settings.boiler.3phase.subtitle": "Jedno-fázovú patrónu zapojte na SSR výstup zodpovedajúci zvolenej fáze.",
  "settings.boiler.HwBatteryPriority": "Procento nabítí batérie od ktorého sa začne ohrievať bojler",
  "settings.boiler.HwBatteryPriority.help": "Ak je nabitie batérie nižšie ako táto hodnota, priorita akumulácie energie je plne dostupná batérii. Ak je nabitie batérie vyššie, bojler začína preberať prioritu a spúšťa ohrev vody z prebytočnej energie FVE - časť energie ide ďalej do batérie do jej dobitia.",
  "settings.boiler.capacity": "Objem bojleru",
  "settings.boiler.capacity_sub": "Nutné zadať len pre spotové obchodovanie",
  "settings.boiler.enabled": "Topná patrona nainstalována",
  "settings.boiler.nominal": "Nominálny príkon",
  "settings.boiler.nominal.subtitle": "Nominálny príkon pre 1 fázu elektrokotle",
  "settings.boiler.phase": "Fáza patróny",
  "settings.boiler.phase.subtitle": "L1 = SSR výstup 1, L2 = SSR výstup 2, L3 = SSR výstup 3.",
  "settings.boiler.prio": "Priorita batérie",
  "settings.boiler.prio.subtitle": "Ak je ON, najprv sa nabijú batérie a následne bojler",
  "settings.boiler.shellies": "Bojler je riadený cez Shelly",
  "settings.boiler.temp_enabled": "Teplotní čidlo nainstalováno",
  "settings.boiler.temp_enabled.subtitle": "Bojler možno bez čidla využiť len pre prebytky",
  "settings.device": "Zariadenie",
  "settings.device.SN": "Sériové číslo",
  "settings.device.id": "ID zariadenia",
  "settings.device.license": "Licence zariadenia",
  "settings.docs": "Návody a další podklady",
  "settings.docs.service_settings_inverter.button": "Prejsť na wiki",
  "settings.docs.service_settings_inverter.subtitle": "Dokumentácia, postupy a ďalšie informácie",
  "settings.docs.service_settings_inverter.title": "Návod na pripojenie striedača",
  "settings.docs.tech_wiki.button": "Prejsť na wiki",
  "settings.docs.tech_wiki.subtitle": "Návody, postupy a další informace",
  "settings.docs.tech_wiki.title": "Technická wiki",
  "settings.docs.user_wiki.button": "Prejsť na wiki",
  "settings.docs.user_wiki.subtitle": "Návody, postupy a další informace",
  "settings.docs.user_wiki.title": "Uživatelská wiki",
  "settings.hdo": "Nastavenie čias HDO",
  "settings.hdo.help": "Nastavenie čias HDO pre výpočet cien elektriny vo vysokom a nízkom tarife. Nižšie je možné zadať časy platnosti nízkeho tarifu.",
  "settings.hdo.on1": "Čas 1",
  "settings.hdo.on2": "Čas 2",
  "settings.hdo.on3": "Čas 3",
  "settings.hdo.on4": "Čas 4",
  "settings.hdo.on5": "Čas 5",
  "settings.hdo.on6": "Čas 6",
  "settings.hdo.regular": "Bežný pracovný deň",
  "settings.hdo.start": "Zapnúť",
  "settings.hdo.stop": "Vypnúť",
  "settings.hdo.type": "Definovat časy pro",
  "settings.hdo.weekend": "Víkendové časy HDO",
  "settings.heatpump": "Tepelné čerpadlo",
  "settings.heatpump.HpBatteryPriority": "Percento nabitia batérie, od ktorého sa zvýši výkon tepelného čerpadla",
  "settings.heatpump.HpBatteryPriority.help": "Ak je nabitie batérie nižšie ako táto hodnota, priorita akumulácie energie je plne dostupná batérii. Ak je nabitie batérie vyššie, tepelné čerpadlo začína preberať prioritu a spúšťa ohrev vody z prebytočnej energie FVE - časť energie ide ďalej do batérie do jej dobitia.",
  "settings.heatpump.enabled": "Tepelné čerpadlo nainstalováno",
  "settings.heatpump.flexiAN": "Flexibilita AN",
  "settings.heatpump.flexiCool": "Flexibilita chlazení",
  "settings.heatpump.flexiHw": "Flexibilita teplej vody",
  "settings.heatpump.flexiRoom": "Flexibilita miestnosti",
  "settings.heatpump.hp_type": "Typ tepelného čerpadla",
  "settings.heatpump.nominal": "Nominálny príkon",
  "settings.heatpump.nominal1": "Nominálny príkon",
  "settings.heatpump.priority": "Tepelné čerpadlo má vyšší prioritu, než batérie",
  "settings.heatpump.priority-wb": "Tepelné čerpadlo má vyšší prioritu, než wallbox",
  "settings.heatwatter": "Bojler",
  "settings.heatwatter.legionella": "Legionella",
  "settings.heatwatter.legionella_temp": "Teplota sanace",
  "settings.heatwatter.legionella_temp.subtitle": "Teplota, na ktorú sa musí minimálne 1x za 14 dní bojler nahriať",
  "settings.inverter_communication_status": "Komunikácia so striedačom",
  "settings.inverter_communication_status.not_ok": "Nenaviazané,{br}pokúšam sa o spojenie...",
  "settings.inverter_communication_status.ok": "Komunikace navázána{br}({count} čtení)",
  "settings.inverter_communication_status.subtitle": "Nadviazanie komunikácie môže trvať niekoľko desiatok sekúnd až pár minút",
  "settings.notification": "Notifikace",
  "settings.notification.battery_max_soc": "Maximálne SOC batérie",
  "settings.notification.battery_max_soc.subtitle": "Notifikácia sa vygeneruje pri dosažení nastaveného maximálneho SOC batérie. Notifikácia sa vygeneruje len 1x denne.",
  "settings.notification.battery_max_soc_value": "Maximálne SOC batérie pre notifikácie",
  "settings.notification.battery_max_soc_value.subtitle": "Nastavte SOC batérie, pri jeho dosiahnutí sa vygeneruje notifikace.",
  "settings.notification.battery_min_soc": "Minimálne SOC batérie",
  "settings.notification.battery_min_soc.subtitle": "Notifikácia sa vygeneruje pri poklesu SOC batérie na nastavenou minimálnu hodnotu. Notifikácia sa vygeneruje len 1x denne.",
  "settings.notification.battery_min_soc_value": "Minimálne SOC batérie pre notifikácie",
  "settings.notification.battery_min_soc_value.subtitle": "Nastavte SOC batérie. Pri poklese na túto hodnotu sa vygeneruje notifikácia.",
  "settings.notification.daily_prediction.subtitle": "Notifikácia sa vygeneruje každý deň v 8:00",
  "settings.notification.heat_pump_limit_exceeded": "Prekročenie limitu spotreby tepelného čerpadla.",
  "settings.notification.heat_pump_limit_exceeded.subtitle": "Notifikácia sa vygeneruje pri prekročení nastaveného limitu spotreby tepelného čerpadla",
  "settings.notification.heat_pump_limit_value": "Denný limit spotreby tepelného čerpadla pre notifikácie",
  "settings.notification.heat_pump_limit_value.subtitle": "Nastavte limit spotreby tepelného čerpadla, pri jeho prekročení sa vygeneruje notifikace.",
  "settings.notification.heat_water_limit_exceeded": "Prekročenie limitu ohrevu vody",
  "settings.notification.heat_water_limit_exceeded.subtitle": "Notifikácia sa vygeneruje pri prekročení nastaveného limitu ohrevu vody",
  "settings.notification.heat_water_limit_value": "Denný limit ohrevu vody pre notifikácie",
  "settings.notification.heat_water_limit_value.subtitle": "Nastavte limit ohrevu vody, pri jeho prekročení sa vygeneruje notifikace.",
  "settings.notification.heat_water_max_temperature": "Dosažena maximálne teplota vody v bojleru",
  "settings.notification.heat_water_max_temperature.subtitle": "Notifikácia sa vygeneruje pri dosažení požadované maximálne teploty vody v bojleru z FV energie",
  "settings.notification.home_consumption_limit_exceeded": "Prekročenie limitu spotreby domácnosti",
  "settings.notification.home_consumption_limit_exceeded.subtitle": "Notifikácia sa vygeneruje pri prekročení nastaveného limitu spotreby domácnosti",
  "settings.notification.home_consumption_limit_value": "Denný limit spotreby domácnosti pre notifikácie",
  "settings.notification.home_consumption_limit_value.subtitle": "Nastavte limit spotreby domácnosti, pri jeho prekročení sa vygeneruje notifikace.",
  "settings.notification.iverter_disconnected": "Výpadok komunikácie striedača",
  "settings.notification.iverter_disconnected.subtitle": "Notifikácia sa vygeneruje pri začiatku a konci výpadku komunikácie so striedačom",
  "settings.notification.negative_spot": "Záporná cena na spotu",
  "settings.notification.negative_spot.subtitle": "Notifikácia sa vygeneruje pri začiatku a konci zápornej ceny na spotu",
  "settings.notification.pv_production_mwh": "Míľnik vo výrobe FV energie",
  "settings.notification.pv_production_mwh.subtitle": "Notifikácia sa vygeneruje ak FVE vygeneruje MWh energie v daném roce",
  "settings.notification.spot_charging_battery": "Začiatok a koniec nabíjania batérie podľa spotovej ceny",
  "settings.notification.spot_charging_battery.subtitle": "Notifikácia sa vygeneruje pri začiatku a konci nabíjania batérie podľa spotovej ceny",
  "settings.notification.spot_daily_prediction": "Denná predpoveď",
  "settings.notification.spot_daily_summary": "Denný súhrn plánu spotu",
  "settings.notification.spot_daily_summary.subtitle": "Notifikácia sa vygeneruje každý den v 8:00",
  "settings.notification.spot_discharging_battery": "Začiatok a koniec vybíjania batérie do siete podľa spotovej ceny",
  "settings.notification.spot_discharging_battery.subtitle": "Notifikácia sa vygeneruje pri začiatku a konci vybíjania batérie do siete podľa spotovej ceny",
  "settings.notification.utility_loss": "Výpadek distribučnej siete",
  "settings.notification.utility_loss.subtitle": "Notifikácia sa vygeneruje pri začiatku a konci výpadku distribučnej siete",
  "settings.notification.wallbox_charging_start_stop": "Začiatok a koniec nabíjania elektromobilu",
  "settings.notification.wallbox_charging_start_stop.subtitle": "Notifikácia sa vygeneruje pri začiatku a konci nabíjania elektromobilu",
  "settings.notification.wallbox_limit_exceeded": "Prekročenie limitu nabíjania elektromobilu",
  "settings.notification.wallbox_limit_exceeded.subtitle": "Notifikácia sa vygeneruje pri prekročení nastaveného limitu nabíjania elektromobilu",
  "settings.notification.wallbox_limit_value": "Denný limit nabíjania elektromobilu pre notifikácie",
  "settings.notification.wallbox_limit_value.subtitle": "Nastavte limit nabíjania elektromobilu, pri jeho prekročení sa vygeneruje notifikace.",
  "settings.notification.webapp.subtitle": "Notifikácie z Infigy môžete dostávať cez webovú aplikáciu.",
  "settings.notification.webapp.title": "Webová aplikácia",
  "settings.other": "Ostatní",
  "settings.other.dark_mode": "Tmavý režim",
  "settings.other.languate": "Jazyk",
  "settings.other.overflow_fronius": "Maximálny pretok do siete je obmedzovaný na strane Fronius striedača",
  "settings.other.overflow_fronius_subtitle": "Táto hodnota je stanovená distribútorom. Prekročenie tejto hodnoty môže viesť k finančným postihom zo strany distribútora.",
  "settings.other.overflow_settings": "Nastavená hodnota pretokov",
  "settings.other.overflow_settings.help": "Ide o servisne nastavenú hodnotu maximálneho pretoku. Táto hodnota je stanovená distribútorom. Prekročenie tejto hodnoty môže viesť k finančným postihom zo strany distribútora.",
  "settings.other.readability_mode": "Velikost písma",
  "settings.photovoltaics": "Fotovoltaická elektrárna",
  "settings.photovoltaics.backup_enabled": "Backup povolen",
  "settings.photovoltaics.backup_enabled.subtitle": "Informácie o nastavení režimu zálohy striedača.",
  "settings.photovoltaics.batterychargingpower": "Nabíjací výkon batérie",
  "settings.photovoltaics.batterychargingpower_sub": "Výkon pre manuálne nabíjanie batérie a spotové nabíjanie z distribučnej siete",
  "settings.photovoltaics.batterydischargingpower": "Vybíjecí výkon batérie",
  "settings.photovoltaics.batterydischargingpower_sub": "Výkon pre spotové vybíjanie batérie do distribučnej siete",
  "settings.photovoltaics.batteryenabled": "Baterie nainstalována",
  "settings.photovoltaics.batterynominal": "Nominálna kapacita batérie",
  "settings.photovoltaics.batterynominal_sub": "Nutné zadať len pre spotové obchodovanie",
  "settings.photovoltaics.enabled": "FVE nainstalována",
  "settings.photovoltaics.gridchargeenabled": "Nabíjanie batérie z distribučnej siete povolené",
  "settings.photovoltaics.inverters-adjust-power": "Aktuálny výkon striedačov",
  "settings.photovoltaics.inverters-nominal": "Nominálny výkon riadených striedačov",
  "settings.photovoltaics.nominal": "Nominálny výkon v paneloch celej elektrárne",
  "settings.photovoltaics.overflow": "Pretok do siete bez obmedzenia",
  "settings.photovoltaics.overflow.value": "Obmedzenie pretoku",
  "settings.photovoltaics.overflow.value.help": "Hodnota obmedzenia pretoku do distribučnej siete. Táto hodnota sa zapíše do striedača. Vo striedači túto hodnotu neupravujte. Obmedzenie pretoku je riadené z Infigy. Zapísanú hodnotu si skontrolujte vo striedači.",
  "settings.photovoltaics.overflow_fronius.value.help": "Hodnota pretoku na strane Fronius striedače. Slúži ako informácia Infigy pre správnu vizualizáciu pretokov.",
  "settings.photovoltaics.settings": "Batéria",
  "settings.photovoltaics.settings.soc_actual": "Vypočtené minimálne nabití",
  "settings.photovoltaics.settings.soc_actual.help": "Táto hodnota je automaticky vypočítaná na základe aktuálneho stavu. Buď sa riadi dle automatického nabitia podľa ročného obdobia, alebo dle manuálneho nastavenia minimálneho nabitia s DS a bez DS. Ak je táto hodnota 100%, tak je vybíjanie baterie zakázané, napr. dle spotového obchodovania.",
  "settings.photovoltaics.settings.soc_grid": "Minimálne nabitie s DS",
  "settings.photovoltaics.settings.soc_grid.help": "Touto hodnotou je možné riadiť minimálne nabitie batérie v % SOC pri dostupnej distribučnej sieti. U Solax v režime Backup je minimálne nabitie batérie 15%.",
  "settings.photovoltaics.settings.temp": "Minimálne nabitie s DS",
  "settings.photovoltaics.settings.temp.help": "Touto hodnotou je možné riadiť minimálne nabitie batérie v % SOC pri dostupnej distribučnej sieti.",
  "settings.photovoltaics.settings.temp_ek": "Minimálne nabitie bez DS",
  "settings.photovoltaics.settings.temp_ek.help": "Touto hodnotou je možné riadiť minimálne nabitie batérie v % SOC pri výpadku distribučnej siete.",
  "settings.photovoltaics.unbalanced_enabled": "Asymetria striedača",
  "settings.photovoltaics.unbalanced_enabled.subtitle": "Informácie o nastavení režimu asymetrie striedača.",
  "settings.photovoltaics_auto_settings": "Automatické riadenie nabitia",
  "settings.photovoltaics_auto_settings.subtitle": "Automatická regulácia nabitia podľa ročného obdobia",
  "settings.plug": "Zásuvky",
  "settings.plug.Led": "Trvalé podsvícení",
  "settings.plug.Led-batt": "Podsvietené pri nabitej baterii",
  "settings.plug.Led-batt.subtitle": "Podsvietené aktívne, ak má bateria aspoň 95%",
  "settings.plug.Led-over": "Podsvietené pri pretoku",
  "settings.plug.enabled": "Zásuvky nainstalovány",
  "settings.plug.enabled.subtitle": "Zásuvky na lokálnej sieti",
  "settings.plug.enabled2": "Druhá zásuvka",
  "settings.plug.enabled3": "Tretia zásuvka",
  "settings.plug.ip1": "IP adresa prvej zásuvky",
  "settings.plug.ip1.label": "IP 1",
  "settings.plug.ip2": "IP adresa druhej zásuvky",
  "settings.plug.ip2.label": "IP 2",
  "settings.plug.ip3": "IP adresa tretjej zásuvky",
  "settings.plug.ip3.label": "IP 3",
  "settings.plug.modulenabled": "Zásuvky na modulu Shelly PRO 3",
  "settings.plug.modulip": "IP adresa modulu",
  "settings.plug.modulip.label": "IP modulu",
  "settings.plug.name1": "Názov prvej zásuvky",
  "settings.plug.name1.label": "Názov",
  "settings.plug.name2": "Názov druhej zásuvky",
  "settings.plug.name2_label": "Názov",
  "settings.plug.name3": "Názov tretjej zásuvky",
  "settings.plug.name3.label": "Názov",
  "settings.plug.statusLed": "Signalizačná dioda",
  "settings.readability_mode.default": "Predvolené",
  "settings.readability_mode.large": "Velká",
  "settings.relay.above_price_relay": "Cena spotu pre sepnutie relé",
  "settings.relay.above_price_relay.subtitle": "Pri cene spotu nad tuto hodnotu dôjde k sepnutiu relé. Ak je cena nižší, dôjde k rozepnutiu relé.",
  "settings.relay.above_price_relay_15m": "Cena spotu pre sepnutie relé (15 min)",
  "settings.relay.above_price_relay_15m.subtitle": "Pri cene spotu nad túto hodnotu dôjde k sepnutiu relé. Ak je cena nižšia, dôjde k rozepnutiu relé.",
  "settings.relay.above_soc_relay": "Nabitie batérie pre sepnutie relé",
  "settings.relay.above_soc_relay.subtitle": "Pri nabití batérie nad tuto hodnotu dôjde k sepnutiu relé",
  "settings.relay.above_soc_relay_hyst": "Hystereza batérie pre rozepnutie relé",
  "settings.relay.above_soc_relay_hyst.subtitle": "Ak sa nabitie batérie zníži o túto hodnotu pod nastavenú pre sepnutie, dôjde k rozepnutiu relé",
  "settings.relay.below_price_relay": "Cena spotu pre sepnutie relé",
  "settings.relay.below_price_relay.subtitle": "Pri cene spotu pod tuto hodnotu dôjde k sepnutiu relé. Ak je cena vyšší, dôjde k rozepnutiu relé.",
  "settings.relay.below_price_relay_15m": "Cena spotu pre sepnutie relé (15 min)",
  "settings.relay.below_price_relay_15m.subtitle": "Pri cene spotu pod túto hodnotu dôjde k sepnutiu relé. Ak je cena vyššia, dôjde k rozepnutiu relé.",
  "settings.relay.below_soc_relay": "Nabitie batérie pre sepnutie relé",
  "settings.relay.below_soc_relay.subtitle": "Pri poklese nabitia batérie pod túto hodnotu dôjde k sepnutiu relé",
  "settings.relay.below_soc_relay_hyst": "Hystereza batérie pre rozepnutie relé",
  "settings.relay.below_soc_relay_hyst.subtitle": "Ak sa nabitie batérie zvýši o túto hodnotu nad nastavenú pre sepnutie, dôjde k rozepnutiu relé",
  "settings.relay.enabled": "Relé nainstalovány",
  "settings.relay.enabled.subtitle": "Integrovaná relé",
  "settings.relay.item.enabled": "Relé {index}",
  "settings.relay.item.name": "Pojmenovanie relé",
  "settings.relay.item.status": "Sepnuto",
  "settings.relay.option": "Podmienka",
  "settings.relay.temp_above_relay.subtitle": "Pri teplote bojleru nad tuto hodnotu dôjde k sepnutiu relé",
  "settings.relay.temp_above_relay_hyst.subtitle": "Ak sa teplota bojleru zníži o túto hodnotu pod nastavenú pre sepnutie, dôjde k rozepnutiu relé",
  "settings.relay.temp_below_relay.subtitle": "Pri teplote bojleru pod tuto hodnotu dôjde k sepnutiu relé",
  "settings.relay.temp_below_relay_hyst": "Hystereza bojlera pre rozepnutie relé",
  "settings.relay.temp_below_relay_hyst.subtitle": "Ak sa teplota bojleru zvýši o túto hodnotu nad nastavenú pre sepnutie, dôjde k rozepnutiu relé",
  "settings.relay.temp_relay": "Teplota bojlera pre sepnutie relé",
  "settings.relay.temp_relay_hyst": "Hystereza bojlera pre rozepnutie relé",
  "settings.relay.type.Active": "Trvalo zapnuté",
  "settings.relay.type.HDO": "Zrcadlit HDO",
  "settings.relay.type.batteryBelowSOC": "Nabitie batérie pod nastavené SOC",
  "settings.relay.type.batteryDischarge": "Vybíjení batérie do siete",
  "settings.relay.type.batteryFull": "Nabitie batérie nad nastavené SOC",
  "settings.relay.type.batteryLow": "Nabitie batérie pod nastavené minimum",
  "settings.relay.type.bojlerFull": "Bojler je takmer natopený",
  "settings.relay.type.hdo": "Zrcadlit HDO",
  "settings.relay.type.heatWaterAboveTemp": "Bojler je natopený nad nastavenú teplotu",
  "settings.relay.type.heatWaterBelowTemp": "Bojler je natopený pod nastavenú teplotu",
  "settings.relay.type.heatWaterMaxTemp": "Bojler je takmer natopený",
  "settings.relay.type.heatWaterTemp": "Bojler je natopený nad nastavenú teplotu",
  "settings.relay.type.none": "Nie je použité, trvalo vypnuté",
  "settings.relay.type.plug1": "Zásuvka 1",
  "settings.relay.type.plug2": "Zásuvka 2",
  "settings.relay.type.plug3": "Zásuvka 3",
  "settings.relay.type.plug4": "Zásuvka 4",
  "settings.relay.type.spotBatteryDischarge": "Vybíjení batérie do siete",
  "settings.relay.type.spotHi": "Vysoká cena spotu (60 min)",
  "settings.relay.type.spotHi15M": "Vysoká cena spotu (15 min)",
  "settings.relay.type.spotLow": "Nízká cena spotu (60 min)",
  "settings.relay.type.spotLow15M": "Nízká cena spotu (15 min)",
  "settings.relay.type.spotMi": "Stredná cena spotu (60 min)",
  "settings.relay.type.spotMi15M": "Stredná cena spotu (15 min)",
  "settings.relay.type.spotNegative": "Zákaz pretokov do siete (60 min)",
  "settings.relay.type.spotNegative15M": "Zákaz pretokov do siete (15 min)",
  "settings.relay.type.spotPriceAbove": "Cena spotu nad nastavenú hodnotu",
  "settings.relay.type.spotPriceAbove15M": "Cena spotu nad nastavenú hodnotu (15 min)",
  "settings.relay.type.spotPriceBelow": "Cena spotu pod nastavenú hodnotu",
  "settings.relay.type.spotPriceBelow15M": "Cena spotu pod nastavenú hodnotu (15 min)",
  "settings.relay.type.spotStopAccumulation": "Akumulácia zastavená, aktívny predaj",
  "settings.relay.type.stopAccumulation": "Akumulácia zastavená, aktívny predaj",
  "settings.relay.type.thermostat1": "Termostat 1",
  "settings.relay.type.thermostat2": "Termostat 2",
  "settings.relay.type.thermostat3": "Termostat 3",
  "settings.relay.type.thermostat4": "Termostat 4",
  "settings.relay.user_advanced_control": "Zobraziť stránku s informáciami užívateľovi",
  "settings.relay.user_advanced_control.subtitle": "Pri povolení sa zobrazí stránka v navigaci",
  "settings.service": "Servis",
  "settings.service.connection_type": "Pripojenie",
  "settings.service.customer": "Meno užívateľa",
  "settings.service.customer-email": "Email užívateľa",
  "settings.service.customer-email-subtitle": "Ak nemá užívateľ založený účet pod týmto emailom, dôjde k automatickému vytvoreniu účtu a odoslaniu registračného emailu",
  "settings.service.customer-email.label": "Email",
  "settings.service.customer-subtitle": "Slúži k identifikácii inštalácie pre firmu a zákazníka",
  "settings.service.customer.label": "Meno",
  "settings.service.exit": "Odhlásiť zo servisu",
  "settings.service.exit.button": "Odhlásiť",
  "settings.service.info": "Inštalácia",
  "settings.service.inverter_type": "Typ striedače",
  "settings.service.inverter_type.label": "Striedač",
  "settings.service.modbus_tcp": "LAN/WiFi",
  "settings.service.network": "Sieť",
  "settings.service.network.help.content": "V zozname je možné vidieť aktuálne pripojené zariadenia do siete Infigy (WiFi nebo kabelem), ich IP adresy, MAC adresy, atd. Ak zariadenie používa DHCP, je možné kliknutím na špendlík a zafixovat IP adresu, ktorú potom DHCP server vždy bude priraďovať - toto je vhodné napr. pre striedač, tepelné čerpadlo, apod. Ak zariadenie používa statickou IP adresu, nemusí sa zobrazovať správne.",
  "settings.service.network.help.title": "Nastavenie siete",
  "settings.service.network.mac": "MAC adresa zariadenia",
  "settings.service.network.online.internet": "Prístup na internet",
  "settings.service.network.online.internet.help": "Prístup na internet je potrebný pre vzdialený prístup, aktualizáciu systému, spotové ceny a ďalšie funkcie. Pre plnú funkčnosť musia byť všetky tri indikátory zelené.{br}{br}Prvý indikátor zobrazuje dostupnosť internetu (ping 8.8.8.8).{br}{br}Druhý indikátor zobrazuje dostupnosť internetu vrátane DNS (ping infigy.cz).{br}{br}Tretí indikátor zobrazuje prístup k interným cloudovým službám Infigy (dostupnosť VPN).{br}{br}Ak je s pripojením problém, skontrolujte prosím kábel, alebo kontaktujte správcu siete, či nemá lokálnu sieť obmedzenia na komunikáciu do internetu.{br}{br}{wikiLink}",
  "settings.service.network.online.internet.help.wikiLink": "Viac informácií v našej wiki.",
  "settings.service.network.online.portal": "Prístup na portál Infigy",
  "settings.service.network.wan": "WAN adresa",
  "settings.service.network.wifi_passphrase": "Heslo WiFi siete",
  "settings.service.network_type": "Sieť",
  "settings.service.network_type.custom": "Ruční nastavení adresy",
  "settings.service.network_type.external": "Místní síť (zákazníka)",
  "settings.service.network_type.internal": "Interní síť Infigy",
  "settings.service.password": "Prístup do servisu",
  "settings.service.password.label": "Heslo",
  "settings.service.relay": "Relé",
  "settings.service.reset": "Reset chyb",
  "settings.service.reset.button": "Reset chyb",
  "settings.service.rs485": "RS485",
  "settings.service.service-email": "Email servisnej firmy",
  "settings.service.service-email-subtitle": "Pre prepojenie zariadenia s inštaláciou je nutné zadat email servisnej firmy, ktorý je uložen v Partnerskej sekcii aplikácie",
  "settings.service.service-email.label": "Email",
  "settings.service.servicer": "Meno inštalácie technika",
  "settings.service.servicer.label": "Meno",
  "settings.service.solidsun_op": "SolidSun OP",
  "settings.service.solidsun_op.label": "SolidSun OP",
  "settings.service.spot": "Spotové obchodovanie",
  "settings.service.tester.label": "Meno testéra",
  "settings.service.thermostat": "Termostat",
  "settings.service.town": "Lokalita (obec)",
  "settings.service.version": "Verzia aplikácie",
  "settings.service.wallbox_type": "Typ wallbox",
  "settings.service.wallbox_type.label": "Wallbox",
  "settings.spot": "Spot",
  "settings.spot.battery.stop_discharge_auto": "Automatické riadenie zákazu vybíjania",
  "settings.spot.battery.stop_discharge_auto.help": "Ak zvolíte tuto možnost, tak systém automaticky bude riadiť vybíjanie batérie a povolí ho iba pri najvyšších denných cenách na spotu.",
  "settings.spot.battery.stop_discharge_auto.subtitle": "Riadenie uschová energii automaticky na najdrahšie hodiny.",
  "settings.spot.battery.stop_discharge_high_price": "Zákaz vybíjania batérie pri nízkej a strednej cene",
  "settings.spot.battery.stop_discharge_high_price.help": "Ak zvolíte túto možnosť, tak pri nízkej a strednej cene spotu sa nebude využívať energia z batérie. Systém nebude batériu vybíjať. Tá sa využije pri vyšších cenách.",
  "settings.spot.battery.stop_discharge_low_price": "Zákaz vybíjania batérie pri nízkej cene",
  "settings.spot.battery.stop_discharge_low_price.help": "Ak zvolíte túto možnosť, tak pri nízkej cene spotu sa nebude využívať energia z batérie. Systém nebude batériu vybíjať. Tá sa využije pri vyšších cenách (stredná a vysoká cena).",
  "settings.spot.battery.stop_discharge_low_price.subtitle": "Riadenie uschová energii na strednú a vysokú cenu energie",
  "settings.spot.battery.stop_discharge_middle_price.subtitle": "Riadenie uschová energiu na vysokú cenu energie",
  "settings.spot.battery_all_overflow_price": "Minimálna cena pre vybíjanie celej kapacity batérie",
  "settings.spot.battery_all_overflow_price.help": "Ak je cena spotu vyššia než táto hodnota, dojde v týchto hodinách k vybíjaniu kapacity batérie do siete až do nastaveného minimálneho SOC. To znamená, že v batérii nebude uchovávaná energia pre nočnú a rannú spotrebu. Po vybití batérie do siete sa bude pre spotrebu objektu nakupovať energia z siete",
  "settings.spot.battery_all_overflow_price.subtitle": "V batérii sa uchová energie pre dennú spotrebu",
  "settings.spot.battery_charge": "Povolené nabíjanie batérie podľa spotu",
  "settings.spot.battery_charge.help": "Ak zvolíte túto možnosť, tak systém naplánuje nabíjanie v dobe najnižších cien. Berie do úvahy aktuálnu úroveň nabitia batérie a jej kapacitu. Na základe týchto parametrov zvolí dĺžku nabíjania tak, aby došlo k jej nabitiu za čo najnižšiu cenu.",
  "settings.spot.battery_charge.subtitle": "Riadenie batérie podľa spotu zvýši amortizáciu batérie",
  "settings.spot.battery_max_soc": "Finálne SOC batérie",
  "settings.spot.battery_max_soc.subtitle": "Maximálne nabitie batérie pri nabíjaní zo siete",
  "settings.spot.battery_overflow": "Povoliť vybíjanie batérie do siete podľa spotu",
  "settings.spot.battery_overflow.help": "Ak zvolíte túto možnosť, tak systém naplánuje vybíjanie batérie do siete v dobe najvyššej dennej ceny a vybije len tú energiu, ktorá nebude potrebná na bežnú spotrebu objektu. Parametre nižšie je možné definovať výšku ceny pre vybitie celej kapacity batérie a vybitie len tej časti kapacity batérie, ktorá nebude potrebná pre nočnú spotrebu.",
  "settings.spot.battery_overflow.subtitle": "Umožní vybiť nadbytok energie z batérie do siete v najvýhodnejšiu hodinu",
  "settings.spot.battery_overflow_price": "Minimálna cena pre vybíjanie batérie",
  "settings.spot.battery_overflow_price.help": "Ak je cena spotu vyššia než táto hodnota, dojde v týchto hodinách k vybíjaniu nadbytočnej kapacity batérie do siete. To znamená, že v batérii sa uchováva energia pre nočnú a rannú spotrebu objektu. Nebude teda dochádzať k nakupovaniu energie z siete",
  "settings.spot.battery_overflow_price.subtitle": "V batérii sa uchová energie pre nočnú spotrebu",
  "settings.spot.battery_strategy": "Stratégia spotového nabíjania batérie",
  "settings.spot.battery_strategy.help": "Týmto posuvníkom môžete jednoducho nastaviť preferenciu využitia batérie pri spotovom obchodovaní. Nižšie hodnoty (od 20 %) znamenajú menšie cyklovanie batérie a teda menej časté nabíjanie/vybíjanie za spotové ceny. Vyššie hodnoty (až do 70 %) znamenajú opak.",
  "settings.spot.battery_strategy_service.subtitle": "Touto voľbou povolíte koncovým používateľom nastaviť stratégiu batérie na záložke Spot",
  "settings.spot.battery_strategy_user": "Umožniť nastavenie stratégie batérie používateľom",
  "settings.spot.battery_strategy_user.subtitle": "20 % = Skôr využívať batériu pre FVE. 70 % = Skôr využívať batériu pre Spot.",
  "settings.spot.install": "Spotové obchodovanie aktívne",
  "settings.spot.latitude": "Zemepisná šírka",
  "settings.spot.latitude.mess": "Šírka",
  "settings.spot.longitude": "Zemepisná dĺžka",
  "settings.spot.longitude.mess": "Dĺžka",
  "settings.spot.min_difference_price_charge_from_grid": "Minimálny rozdiel ceny na spotu pre nabíjanie batérie zo siete",
  "settings.spot.min_difference_price_charge_from_grid.help": "Týmto parametrom je možné riadiť nabíjanie batérie zo spotu pri nízkom rozdiele medzi najnižšou a najvyššou cenou. Ak je parameter 2 Kč a rozdiel medzi najvyššou cenou (3 Kč) a najnižšou cenou (1 Kč) spotu je nižší, tak sa ten deň nabíjanie batérie zo siete nenaplánuje.",
  "settings.spot.min_difference_price_charge_from_grid.subtitle": "Minimálny rozdiel ceny na spotu počas dňa, aby mohlo dôjsť k nabíjaniu batérie zo siete",
  "settings.spot.overflow": "Povoliť optimalizáciu pretoku podľa spotu",
  "settings.spot.overflow.help": "Ak zvolíte túto možnosť, tak systém uprednostní pretok do siete pred nabíjaním batérie v dobe vyšších a stredných spotových cien. Deje sa len v ročných obdobiach, v ktorých predpokladáme prebytok energie z FVE a dochádza k tomu zvyčajne ráno. Optimalizácia neprebieha v nízkej spotovej cene, keď je prioritou nabíjanie batérie z FVE.",
  "settings.spot.overflow.subtitle": "Umožní uprednostnenie pretoku pred akumuláciou",
  "settings.spot.overflow_offset": "Maximálny pretok pri zápornej cene",
  "settings.spot.overflow_offset.help": "Hodnota udáva pretok do distribučnej siete pri zápornej cene. Túto funkciu odporúčame využívať v prípade energetické komunity.",
  "settings.spot.overflow_offset.subtitle": "Hodnotu nie je možné nastaviť vyššiu ako maximálny pretok",
  "settings.spot.price.period": "Časové rozlišení",
  "settings.spot.price_above_price": "Nastavená cena spotu",
  "settings.spot.price_below": "Nastavená cena spotu",
  "settings.spot.price_distribution_hi": "Cena za distribúciu vo vysokom tarife",
  "settings.spot.price_distribution_hi.help": "Cena za distribúciu vo vysokom tarife v kč/kWh. Táto cena sa pripočítava k cene spotu, ak je aktívny vysoký tarif. Musia byť nastavené časy HDO pre správny výpočet ceny vo vysokom a nízkom tarife. Túto sumu hľadajte vo vyúčtovaní za elektrinu.",
  "settings.spot.price_distribution_low": "Cena za distribúciu v nízkom tarife",
  "settings.spot.price_distribution_low.help": "Cena za distribúciu v nízkom tarife v kč/kWh. Táto cena sa pripočítava k cene spotu, ak je aktívny nízký tarif. Musia byť nastavené časy HDO pre správny výpočet ceny vo vysokom a nízkom tarife. Túto sumu hľadajte vo vyúčtovaní za elektrinu.",
  "settings.spot.price_offset": "Cena pre zákaz pretokov",
  "settings.spot.price_offset.help": "Odporúčame nastaviť minimálne vo výške provízie/poplatku obchodníkovi za predaj pretokov do siete.",
  "settings.spot.price_offset.subtitle": "Minimálna cena spotu, pod ktorou sa zakazujú pretoky. Hodnota je porovnávaná s denným trhom bez distribučnej sadzby.",
  "settings.spot.region": "Region",
  "settings.thermostat.hp-blocked": "Blokácia tepelného čerpadla",
  "settings.thermostat.hysteresis": "Hystereza teploty",
  "settings.thermostat.install": "Termostat aktívny",
  "settings.thermostat.name.label": "Názov",
  "settings.thermostat.name1": "Pomenovanie termostatu 1",
  "settings.thermostat.name2": "Pomenovanie termostatu 2",
  "settings.thermostat.name3": "Pomenovanie termostatu 3",
  "settings.thermostat.name4": "Pomenovanie termostatu 4",
  "settings.thermostat.nominal": "Nominálny príkon zdroja",
  "settings.thermostat.number-of-thermostat": "Počet termostatov",
  "settings.utility": "Parametre domu",
  "settings.utility.loadpercent": "Aktuálna zatížení jističe",
  "settings.utility.numberofphase": "Trojfázová instalace",
  "settings.utility.settings.ampers": "Velikost jističe",
  "settings.utility.settings.loadpercent": "Krizové zatížení",
  "settings.utility.settings.loadpercent_max": "Pri prekročení dochádza k obmedzovaniu spotreby",
  "settings.wallbox": "Wallbox",
  "settings.wallbox.install": "Wallbox aktívny",
  "settings.wallbox.name": "Názov wallboxu {number}",
  "settings.wallbox.spot": "Wallbox",
  "shellies.list": "Shellies",
  "shellies.mqtt_broker_running": "Stav MQTT Brokerka",
  "shellies.settings": "Nastavenie",
  "shellies.settings.boiler.active": "Bojler pripojený cez Shellies",
  "shellies.settings.boiler.id": "ID shellies",
  "shellies.settings.boiler.id.label": "ID",
  "shellies.title": "Shellies",
  "spot.chartview": "Zobraziť cenu bez distribučného poplatku",
  "spot.draft": "Režimy pre dnešok",
  "spot.draft.actualpricehi": "Aktuálna cena je vysoká, zniž spotrebu",
  "spot.draft.actualpricelow": "Aktuálna cena je nízká, zvyš spotrebu",
  "spot.draft.hesLevel": "Úroveň riadenia HES",
  "spot.draft.hiprice": "Hranice sníženého odberu",
  "spot.draft.info": "Režimy a odporúčania pre dnešný deň",
  "spot.draft.lowprice": "Hranice zvýšeného odberu",
  "spot.draft.todaystatus_HP": "Akumulácia tepelného čerpadla",
  "spot.draft.todaystatus_HW": "Akumulácia teplej vody",
  "spot.draft.todaystatus_bat": "Akumulácia batérie",
  "spot.draft.todaystatus_em": "Pretok",
  "spot.explanation": "Vysvetlenie režimov",
  "spot.explanation.battery_discharge_to_grid": "Vybíjanie batérie do siete",
  "spot.explanation.battery_discharge_to_home": "Vybíjanie batérie",
  "spot.explanation.hw": "Nabíjanie batérie zo siete",
  "spot.explanation.info": "Detailné vysvetlenie režimov pre dnešný deň",
  "spot.flexibility": "Odhad flexibility pre dnešek",
  "spot.prediction": "Odhady energií pre dnešek",
  "spot.prediction.battery": "Dispozičná akumulácia batérie",
  "spot.prediction.home": "Bežná spotreba objektu",
  "spot.prediction.hp": "Tepelné čerpadlo",
  "spot.prediction.hw": "Dispozičná akumulácia bojleru",
  "spot.prediction.pv": "Výroba elektrárne",
  "spot.prediction.sale": "Zostávajúca energia na predaj prebytočkov",
  "spot.prediction.sale.help": "Zostávajúca plánovaná denná výška prebytočkov, ktorá bude uprednostnená ako pretok do siete pred akumuláciou do batérie.",
  "spot.price.period.15min": "15 min",
  "spot.price.period.60min": "60 min",
  "spot.region.cz": "CZ",
  "spot.region.nl": "NL",
  "spot.region.sk": "SK",
  "spot.status": "Spotové obchodování",
  "spot.summary.battery_charge_from_grid": "Nabíjanie zo siete",
  "spot.summary.battery_charge_from_grid.help": "Nabíjanie batérie zo siete podľa spotu je možné zakázať či povoliť. Možno tak urobiť v nastavení. Nabíjanie batérie systém naplánuje v dobe nízkych cien a berie do úvahy aktuálnu úroveň nabitia batérie a jej kapacitu. Na základe týchto parametrov zvolí dĺžku nabíjania tak, aby došlo k jej nabitiu za čo najnižšiu cenu.",
  "spot.summary.battery_discharge": "Vybíjení batérie",
  "spot.summary.battery_discharge.help": "Vybíjanie batérie do objektu na spotu je možné zakázať či povoliť. Možno tak urobiť v nastavení. Vybíjanie batérie sa zvyčajne zakazuje v dobe nízkych cien, keď je lepšie brať energiu zo siete a v batérii ju uchovať na drahšie časy.",
  "spot.summary.battery_discharge_to_grid": "Vybíjení do siete",
  "spot.summary.battery_discharge_to_grid.help": "Vybíjanie batérie do siete je možné zakázať či povoliť. Možno tak urobiť v nastavení. Vybíjanie batérie do siete určí systém v dobe najvyššej dennej ceny a vybije len tú energiu, ktorá nebude potrebná na bežnú spotrebu objektu.",
  "spot.summary.boiler": "Bojler",
  "spot.summary.boiler.help": "Predohrievanie bojlera systém naplánuje v dobe nízkych cien a berie do úvahy aktuálnu teplotu vody v bojleri, jeho kapacitu a požadovanú teplotu. Na základe týchto parametrov zvolí dĺžku predohrievania tak, aby došlo k jeho nahriatiu.",
  "spot.summary.heat_pump": "Tepelné čerpadlo",
  "spot.summary.heat_pump.help": "Tepelné čerpadlo môže bežať v troch režimoch: zvýšený výkon, bežný chod a obmedzený výkon. Zvýšený výkon sa využíva v dobe nízkych cien, bežný chod v dobe stredných cien a obmedzený výkon v dobe vysokých cien. Odloženie spotreby či zvýšenie spotreby možno povoliť v menu tepelného čerpadla.",
  "spot.summary.heat_pump_level.increase": "Zýšený výkon",
  "spot.summary.heat_pump_level.normal": "Bežný chod",
  "spot.summary.heat_pump_level.reduction": "Omezený výkon",
  "spot.summary.price": "Cena",
  "spot.summary.price_buy": "Cena s distribučnou",
  "spot.summary.price_distribution": "Distribučná",
  "spot.summary.price_level": "Úroveň ceny",
  "spot.summary.price_level.help": "Infigy zoradí hodinové ceny spotu od najnižšej po najvyššiu a rozdelí ich do troch častí, približne rovnako veľkých. Ak hodinové ceny začínajú na hodnote 3 Kč a končia na hodnote 10 Kč, tak nízka cena môže mať rozptyl 3-6 Kč, stredná 6-7 Kč a vysoká 7-10 Kč. Rozptyl bude každý deň iný, záleží na početnosti hodnôt v danej úrovni ceny.",
  "spot.summary.price_level.hi": "Vysoká cena",
  "spot.summary.price_level.low": "Nízká cena",
  "spot.summary.price_level.mid": "Stredná cena",
  "spot.summary.price_level_15m": "Hladina ceny (15 min)",
  "spot.summary.price_sell": "Cena bez distribučnej",
  "spot.summary.spotOverflow": "Pretok do distribučnej siete.",
  "spot.summary.spotOverflow.allowed": "Povolené",
  "spot.summary.spotOverflow.help": "Povolenie pretoku do siete pri spotovom obchodovaní porovnáva cenu spotu v danú hodinu a ak je nižšia ako Cena pre zákaz pretokov z nastavenia, tak systém automaticky v danú hodinu pretok zakáže.",
  "spot.summary.spotOverflow.restricted": "Omezený",
  "spot.summary.state.active": "Aktívne",
  "spot.summary.state.inactive": "Neaktívne",
  "spot.summary.time": "Čas",
  "spot.user.parameters": "Parametre spotového obchodovania",
  "spot_wizard.banner.button": "Potrebujete pomoc? Môžem Vám pomôcť",
  "spot_wizard.banner.subtitle": "Sprievodca vám pomôže nastaviť spotové obchodovanie",
  "spot_wizard.banner.title": "Potrebujete pomoc? Môžem Vám pomôcť",
  "spot_wizard.battery_discharge.paragraph1": "Toto nastavenie zakáže vybíjanie baterie pri nízkom tarife spotu. Díky tomu si uchováte energiu pre vyššie ceny dňa.",
  "spot_wizard.battery_discharge.paragraph2": "Ak máte len predaj energie na spotu, môžete zákaz deaktivovať.",
  "spot_wizard.battery_discharge.title": "Vybíjanie baterie do vlastného spotrebného odboru",
  "spot_wizard.battery_purchase.paragraph1": "Toto nastavenie umožní pri nízkom výrobe elektrárne nabít bateriu z nízkého tarife spotu.",
  "spot_wizard.battery_purchase.paragraph2": "Venujte pozornosť nastaveniu stratégie. Ak nastavíte 20%, Infigy bude spíše čakať na fotovoltaiku. Naopak pri nastavení 70% bude spíše nakupovať na spotu. Doporučíme nastaviť 25%.",
  "spot_wizard.battery_purchase.paragraph3": "Ak máte len predaj energie na spotu, môžete nabíjanie deaktivovať.",
  "spot_wizard.battery_purchase.title": "Kúpa energie do batérie",
  "spot_wizard.boiler.paragraph1": "Toto nastavenie umožní pri nízkom výrobe elektrárne ohrievať bojler z najlacnejších cen dňa do nastavenej teploty. Infigy stále udržuje základnú teplotu a využíva navýšenie teploty na teplotu zo spotu.",
  "spot_wizard.boiler.paragraph2": "Zároveň je možné blokovať ohrev pri strednej a alebo vysokých cenách.",
  "spot_wizard.boiler.paragraph3": "Ak máte len predaj energie na spotu, môžete teplotu nastaviť na 10°C a deaktivovať blokáciu ohrevu.",
  "spot_wizard.boiler.title": "Ohrev bojleru",
  "spot_wizard.dialog.finish": "Dokončiť",
  "spot_wizard.dialog.next": "Ďalší",
  "spot_wizard.dialog.prev": "Späť",
  "spot_wizard.dialog.step": "Krok {current} z {total}",
  "spot_wizard.dialog.title": "Sprievodca nastavením spotu",
  "spot_wizard.distribution_prices.title": "Zadajte cenu za distribúciu v nízkom a vysokom tarife",
  "spot_wizard.done.description": "Prešli ste nastavením spotu. Všetky parametre je možné upraviť v spodnej časti stránky Spot, kde môžete tiež opäť vyvolať tohto sprievodcu.",
  "spot_wizard.done.title": "Dokončené",
  "spot_wizard.evening_peak_discharge.paragraph1": "Infigy automaticky odhadne spotrebu energie do ranných hodín. Nadbytok môže byť predajný za najvyššiu cenu dňa.",
  "spot_wizard.evening_peak_discharge.paragraph2": "Ak máte len nákup energie na spotu, môžete vybíjanie deaktivovať.",
  "spot_wizard.evening_peak_discharge.title": "Vybíjanie batérie pri večernom vrchu",
  "spot_wizard.general_settings.title": "Najprv obecné nastavenie",
  "spot_wizard.hdo_times.title": "Nastavenie HDO časov určí obdobie nízkého tarifu",
  "spot_wizard.heat_pump.paragraph1": "Toto nastavenie umožní pri nízkom výrobe elektrárne navyšovať výkon tepelného čerpadla pri nízkom tarife a naopak znížiť výkon pri vysokých cenách.",
  "spot_wizard.heat_pump.paragraph2": "Ak máte len predaj energie na spotu, odloženie i zvýšenie spotreby deaktivovať.",
  "spot_wizard.heat_pump.title": "Tepelné čerpadlo",
  "spot_wizard.info.button1": "Prečo nie je môj batéria dnes nabíjaná zo spotu?",
  "spot_wizard.info.button2": "Prečo nie je môj batéria dnes vybíjaná do spotu?",
  "spot_wizard.info.button3": "Potrebujem pomoc s nastavením",
  "spot_wizard.info.help1.title": "Prečo nie je môj batéria dnes nabíjaná zo spotu?",
  "spot_wizard.info.help2.title": "Prečo nie je môj batéria dnes vybíjaná do spotu?",
  "spot_wizard.info.title": "Informácie o spotovom obchodovaní",
  "spot_wizard.overflow_limit.paragraph1": "Ak máte spot len pre nákup energie, môžete nastaviť -10 Kč. Pretok je obmedzený na maximálnu veľkosť nastavenú servisným technikom.",
  "spot_wizard.overflow_limit.paragraph2": "Ak máte spot aj pre predaj energie, je výhodné zastaviť akumuláciu pri cene, ktorá odpovedá provízii Vašeho dodávateľa. Provízia je najčastejšie 0.30 - 0.70 Kč/kWh.",
  "spot_wizard.overflow_limit.title": "Omezenie pretoku do siete",
  "spot_wizard.preferential_sale.paragraph1": "Táto funkcia nastaví prioritu pretoku do siete počas ranného vrcholu. Energia sa prednostne predáva do siete namiesto akumulácie do batérie, bojlera a tepelného čerpadla. Akumulácia sa znova aktivuje pri nízkej cene alebo po predaji odhadovaného nadbytku energie.",
  "spot_wizard.preferential_sale.paragraph2": "Ak máte len nákup energie na spotu, môžete funkciu deaktivovať.",
  "spot_wizard.preferential_sale.title": "Prednostný predaj energie",
  "statistics.battery.statistics": "Úroveň nabitia batérie",
  "statistics.boiler.statistics": "Ohrev bojlera elektrokotlom",
  "statistics.electrical_grid.statistics": "Nákup z distribučnej siete",
  "statistics.electrical_grid.statistics_house_consumption": "Spotreba objektu",
  "statistics.electrical_grid.statistics_overflow": "Pretok do distribučnej siete",
  "statistics.heatpump.statistics": "Spotreba kompresoru",
  "statistics.outdoor_temperature.statistics": "Vonkajšia teplota",
  "statistics.photovoltaics.statistics": "Výroba elektrárne",
  "statistics.plug.statistics": "Spotreba zásuvky",
  "statistics.wind.statistics": "Výroba veterné elektrárne",
  "stats_delete.button": "Smazať",
  "stats_delete.cancel": "Zrušiť",
  "stats_delete.confirm": "Smazať",
  "stats_delete.confirm.title": "Naozaj chcete smazat všetky štatistiky?",
  "stats_delete.title": "Smazať všetky štatistiky",
  "stats_export.button": "Export",
  "stats_export.from": "Od",
  "stats_export.metric": "Metrika",
  "stats_export.title": "Exportovat statistiky",
  "stats_export.to": "Od",
  "status.heatWater.flexibility": "Flexibilita aktívna, vykurovanie teplej vody",
  "status.heatWater.heating": "Vykurovanie teplej vody",
  "status.heatWater.hwError": "Bojler je nahriaty nebo nedostupný",
  "status.heatWater.inverterError": "Predohrev bojlera neaktívny, nie je dostupný striedač",
  "status.heatWater.legionella": "Sanace vody",
  "status.heatWater.notConnected": "Nemožno nadviazať spojenie",
  "status.heatWater.notLicensed": "Riadenie bojlera nie je licencované",
  "status.heatWater.off": "Vypnuté",
  "status.heatWater.overload": "Preťaženie siete, vykurovanie zastavené",
  "status.heatWater.pvHeating": "Vykurovanie z prebytočkov",
  "status.heatWater.smartMeterError": "Predohrev bojlera neaktívny, nie je dostupný elektromer",
  "status.heatWater.spotHeating": "Vykurovanie teplej vody zo spotu",
  "status.heatWater.stop": "STOP",
  "status.heatWater.stopHDO": "Ohrev blokovaný pri vysokom tarife",
  "status.heatWater.stopSOC": "Blokácia vykurovania, nízký stav batérie",
  "status.heatWater.stopSell": "Predohrev blokovaný, predaj energie",
  "status.heatWater.tempError": "Teplotné čidlo nie je dostupné",
  "status.photovoltaic.dischargeBlockedByComponents": "Vybíjanie baterie pozastavené kvôli spotrebe vybraných technológií",
  "status.photovoltaic.dischargeBlockedByHDO": "Vybíjanie baterie pozastavené, aktívny vysoký tarif (HDO)",
  "status.photovoltaic.discharging": "Vybíjanie batérie",
  "status.photovoltaic.distributionLimit": "Distribučná omezenie výkonu",
  "status.photovoltaic.feedInPriority": "Priorita pretoku do siete",
  "status.photovoltaic.flexibilityBatteryStop": "Flexibilita aktívna, zastavené vybíjanie aj nabíjanie batérie",
  "status.photovoltaic.flexibilityCharging": "Flexibilita aktívna, nabíjanie baterie zo siete",
  "status.photovoltaic.flexibilityDischarging": "Flexibilita aktívna, vybíjanie baterie do siete",
  "status.photovoltaic.flexibilityDoNotDischarge": "Flexibilita aktívna, zákaz vybíjania batérie",
  "status.photovoltaic.flexibilityFeedInPriority": "Flexibilita aktívna, prednostný predaj energie do siete",
  "status.photovoltaic.flexibilityOverflowRestricted": "Flexibilita aktívna, zákaz pretoku do siete",
  "status.photovoltaic.forcedOverflow": "Flexibilita aktívna, vynútený pretok do siete",
  "status.photovoltaic.idle": "Režim spánku",
  "status.photovoltaic.manualCharging": "Ručné nabíjanie batérie",
  "status.photovoltaic.manualDischarging": "Ručné vybíjanie batérie",
  "status.photovoltaic.noneInverter": "Typ striedača nenastavený",
  "status.photovoltaic.notConnected": "Nemožno nadviazať spojenie",
  "status.photovoltaic.notLicensed": "Riadenie FVE nie je licencované",
  "status.photovoltaic.planCharge": "Plánované nabíjanie batérie",
  "status.photovoltaic.planDischarge": "Plánované vybíjanie batérie",
  "status.photovoltaic.production": "Výroba energie",
  "status.photovoltaic.sellBatteryEnergy": "Predaj energie z batérie",
  "status.photovoltaic.spotCharging": "Nabíjanie baterie zo spotu",
  "status.photovoltaic.spotStopDischarging": "Zastavené vybíjanie, je nízká cena na spotu",
  "status.photovoltaic.standby": "Stand-by režim",
  "status.photovoltaic.startUp": "Startovací režim",
  "status.plug.batteryControl": "Zásuvka aktívna podľa batérie",
  "status.plug.manualControl": "Zásuvka aktívna v manuálnom móde",
  "status.plug.notActive": "Zásuvka neaktívna",
  "status.plug.notConnected": "Zásuvka nie je dostupná",
  "status.plug.overflowControl": "Zásuvka aktívna podľa pretoku",
  "status.plug.spotControl": "Zásuvka aktívna podľa spotu",
  "status.plug.stop": "STOP",
  "status.plug.timeControl": "Zásuvka aktívna podľa času",
  "status.smartMeter.consumption": "Bežný odber domu",
  "status.smartMeter.maxLoad": "Maximálny odber domu",
  "status.smartMeter.none": "",
  "status.smartMeter.overflow": "Pretok energie",
  "status.smartMeter.overflowLimited": "Pretok obmedzený z dôvodu zápornej ceny",
  "status.smartMeter.shortage": "Výpadek distribučnej siete",
  "status.spotBattery.flexibilityPV": "Flexibilita využita pre FVE",
  "status.spotBattery.flexibilitySpot": "Flexibilita využita pre SPOT",
  "status.spotBattery.noData": "Pre riadenie nie sú aktuálne dáta",
  "status.spotBattery.spotNotLicensed": "Spot nie je licencovaný",
  "status.spotBatteryChargeFromGrid.batteryChargingNotActive": "Není aktivované nabíjanie z siete",
  "status.spotBatteryChargeFromGrid.batteryChargingPlanned": "Dnes je nabíjanie aktívne",
  "status.spotBatteryChargeFromGrid.enoughPVEnergy": "Dnes sa očakáva denný prebytok pre nabitie batérie",
  "status.spotBatteryChargeFromGrid.priceDifferenceTooLow": "Dnes nie je splnený minimálny rozdiel ceny",
  "status.spotBatteryChargeFromGrid.spotNotActive": "Není aktívne spotové obchodovanie",
  "status.spotBatteryDischargeToGrid.batteryDischargingNotActive": "Není aktivované vybíjanie do siete",
  "status.spotBatteryDischargeToGrid.batteryDischargingPlanned": "Dnes je vybíjanie aktívne",
  "status.spotBatteryDischargeToGrid.minPriceNotReached": "Dnes nie je splnená minimálna cena pre predaj",
  "status.spotBatteryDischargeToGrid.notEnoughBatteryEnergy": "Dnes sa očakáva vybitie batérie cez noc do vlastnej spotreby",
  "status.spotBatteryDischargeToGrid.spotNotActive": "Není aktívne spotové obchodovanie",
  "status.spotBatteryDischargeToHome.automaticDischargeMode": "Automatické vybíjanie batérie dle kapacity",
  "status.spotBatteryDischargeToHome.highPriceDischargeMode": "Vybíjanie batérie pri vysokej cene",
  "status.spotBatteryDischargeToHome.mediumAndHighPriceDischargeMode": "Vybíjanie batérie pri strednej a vysokej cene",
  "status.spotBatteryDischargeToHome.notControlled": "Vybíjanie batérie nie je obmedzené",
  "status.spotHeatPump.flexibilityPV": "Flexibilita využitá pre FVE",
  "status.spotHeatPump.flexibilitySpot": "Flexibilita využitá pre SPOT",
  "status.spotHeatPump.noData": "Pre riadenie nie sú aktuálne dáta",
  "status.spotHeatPump.spotNotLicensed": "Spot nie je licencovaný",
  "status.spotHeatWater.flexibilityPV": "Flexibilita využitá pre FVE",
  "status.spotHeatWater.flexibilitySpot": "Flexibilita využitá pre SPOT",
  "status.spotHeatWater.noData": "Pre riadenie nie sú aktuálne dáta",
  "status.spotHeatWater.spotNotLicensed": "Spot nie je licencovaný",
  "status.spotSmartMeter.noData": "Pre riadenie nie sú aktuálne dáta",
  "status.spotSmartMeter.overflowDisabled": "Trvalé obmedzenia pretoku energie",
  "status.spotSmartMeter.overflowFlexibilitySell": "Optimalizácia pretoku pre predaj",
  "status.spotSmartMeter.overflowLimited": "Pretok obmedzený z dôvodu zápornej ceny",
  "status.spotSmartMeter.spotNotLicensed": "Spot nie je licencovaný",
  "status.spotSmartMeter.withoutReduction": "Bez obmedzenia pretoku energie",
  "status.wind.production": "Výroba elektriny",
  "status.wind.stop": "STOP",
  "status.wind.unavailable": "Zariadenie nie je dostupné",
  "subscriptions.fetch": "Aktualizovať predplatné",
  "subscriptions.fetch.button": "Aktualizovať predplatné",
  "subscriptions.last_fetch_at": "Poslední aktualizace",
  "subscriptions.premium_active": "Premium aktívny",
  "subscriptions.title": "Predplatné",
  "test-product.app": "Aplikácia",
  "test-product.settings": "Nastavenie aplikácie",
  "test-product.settings.distribution": "Distribúcia",
  "test-product.settings.distribution.Dzd": "DZD",
  "test-product.settings.distribution.Infigy": "Infigy",
  "test-product.settings.distribution.solid_sun": "SolidSun",
  "test-product.settings.license": "Licence",
  "test-product.settings.license.HW": "HW",
  "test-product.settings.license.Industrial": "Industrial",
  "test-product.settings.license.Play": "PLAY",
  "test-product.settings.license.Smart": "Smart",
  "test-product.settings.license.basic": "Basic",
  "test-product.test": "Test zariadenia",
  "test-product.test.DC": "Kontrola DC obvodu",
  "test-product.test.DC.subtitle": "Dotaženie svoriek, dimenzie káblov",
  "test-product.test.component": "Kontrola komponentov",
  "test-product.test.component.subtitle": "Je priložené čidlo, štítky, ...?",
  "test-product.test.electricmeter": "Kontrola elektromera",
  "test-product.test.electricmeter.subtitle": "Kontrola osadenia elektromera pre striedač",
  "test-product.test.internet-connect": "Pripojenie k internetu",
  "test-product.test.inverter-connect": "Pripojenie striedača",
  "test-product.test.license": "Licencia",
  "test-product.test.license-info": "Test skončí za:",
  "test-product.test.phase_1": "Test 1. fáze",
  "test-product.test.phase_2": "Test 2. fáze",
  "test-product.test.phase_3": "Test 3. fáze",
  "test-product.test.serialNumber": "Výrobní číslo jednotky",
  "test-product.test.serialNumber.label": "Sériové číslo",
  "test-product.test.serialNumber.subtitle": "Bez výrobného čísla nemožno zadať meno testera a aktivovať test",
  "test-product.test.serialNumberSwitchboard": "Výrobné číslo rozvádzača",
  "test-product.test.serialNumberSwitchboard.label": "Sériové číslo",
  "test-product.test.serialNumberSwitchboard.subtitle": "Vyplniť v prípade, že je zariadenie v originálnom rozvádzači",
  "test-product.test.start": "Ak je zariadenie pripojené",
  "test-product.test.start.button": "Aktivovat test",
  "test-product.test.switchboard": "Kontrola zhody rozvádzača",
  "test-product.test.switchboard.subtitle": "Kontrola dotaženia svoriek, umiestnenia komponentov, správne dimenzie káblov",
  "test-product.test.temp": "Teplotní čidlo",
  "test-product.test.tester": "Zariadenie otestoval",
  "test-product.test.tester.subtitle": "Bez mena nemožno aktivovať test",
  "thermostat.general": "Společné nastavení",
  "thermostat.general.cooling": "Chladenie aktívne",
  "thermostat.general.cooling.pvstability": "Potenciál aktivácie zdroja",
  "thermostat.general.heating": "Vykurovanie aktívne",
  "thermostat.range": "Termostat",
  "thermostat.range.flexibility-temperature": "Flexibilná teplota",
  "thermostat.range.flexibility-temperature.subtitle": "Teplota, o ktorú je možné predohriať alebo predchladiť dom",
  "thermostat.range.flexibility_status": "Režim flexibility termostatu",
  "thermostat.range.on": "Termostat aktívny",
  "thermostat.range.on.subtitle": "Základná teplota",
  "thermostat.range.pv-flexibility": "Riadenie podľa fotovoltaiky",
  "thermostat.range.set_temperature": "Nastavená teplota",
  "thermostat.range.sp-flexibility-down": "Odloženie spotreby popodľa spotu",
  "thermostat.range.sp-flexibility-up": "Zvýšenie spotreby popodľa spotu",
  "thermostat.range.status": "Režim termostatu",
  "thermostat.range.temperature": "Aktuálna teplota",
  "thermostat.statisticsTemp": "Teplota thermostatu",
  "thermostat.status": "Režim termostatu",
  "wallbox.3a.on": "Mód 3A",
  "wallbox.3a.on_sub": "Nabíjanie môže brať 3A z distribučnej siete",
  "wallbox.6a.on": "Mód 6A",
  "wallbox.6a.on_sub": "Nabíjanie len z FVE",
  "wallbox.NO_CHARGE": "Nenabíjaj",
  "wallbox.NO_CHARGE.on_sub": "Nabíjanie je trvalo blokované, spustí ho iba časový plán",
  "wallbox.PV": "Nabíjanie podľa batérie",
  "wallbox.PV.batteryStart": "Zapnúť pri nabití",
  "wallbox.PV.batteryStart.subtitle": "Nabitie batérie, pri ktorom sa aktivuje nabíjanie",
  "wallbox.PV.batteryStop": "Vypnúť pri nabití",
  "wallbox.PV.batteryStop.subtitle": "Nabitie batérie, pri ktorom sa vypne nabíjanie",
  "wallbox.PV.on": "Aktivní",
  "wallbox.PV.on_sub": "Po dosiahnutí základnej energie dôjde k nabíjaniu len pri nabitej batérii",
  "wallbox.PV2": "Nabíjanie podľa FVE",
  "wallbox.PV2.on": "Aktivní",
  "wallbox.PV2.on_sub": "Riadenie nabíjania podľa výkonu FVE",
  "wallbox.PV_FAST": "Prednostné nabíjanie podľa batérie",
  "wallbox.PV_FAST.batteryMinSoc": "Minimálna rezerva batérie",
  "wallbox.PV_FAST.batteryMinSoc.subtitle": "Batéria sa kvôli nabíjaniu automobilu nevybije pod túto hodnotu. Kým nie je hodnota prekročená, nabíjanie čaká",
  "wallbox.PV_FAST.on_sub": "Nabíjanie automobilu bude úplne prioritné. Bude využívaná iba energia z batérie alebo FVE",
  "wallbox.SPOT": "Nabíjanie podľa spotu",
  "wallbox.SPOT.hi": "Blokovať nabíjanie pri vysokej cene",
  "wallbox.SPOT.mi": "Blokovať nabíjanie pri strednej cene",
  "wallbox.SPOT.on": "Aktivní",
  "wallbox.SPOT.on_sub": "Po dosiahnutí základnej energie dôjde k blokovaniu pri vysokej cene spotu",
  "wallbox.active": "{name}",
  "wallbox.active.subtitle": "Aktívny",
  "wallbox.alfen": "Alfen",
  "wallbox.authorization.status": "Autorizácia",
  "wallbox.authorization.status.authorized": "Autorizované{cardInfo}",
  "wallbox.authorization.status.denied": "Odmietnuté{cardInfo}",
  "wallbox.authorization.status.pending": "Nie je autorizované",
  "wallbox.authorization.status.unknown": "Neznámy stav",
  "wallbox.az_router": "AZ Router",
  "wallbox.common": "Obecné informácie",
  "wallbox.common.power": "Aktuálna spotreba",
  "wallbox.common.power_today": "Dnešná spotreba:",
  "wallbox.common.power_total": "Celková spotreba",
  "wallbox.common.power_year": "Ročná spotreba:",
  "wallbox.control": "Režim nabíjania",
  "wallbox.ecovolter": "EcoVolter",
  "wallbox.evmate": "EVmate",
  "wallbox.fast-charge": "Rýchle nabitie",
  "wallbox.fast-charge.energy": "Energia pre rýchle nabitie",
  "wallbox.fast-charge.energy_actual": "Nabíjacia energia v aktuálnom cykle",
  "wallbox.fast-charge.energy_sub": "Energia, ktorá je vždy čo najrýchlejšie nabitá. Po dosiahnutí tejto hodnoty je nabitie riadené jedným z režimov",
  "wallbox.goodwe-ev-charger": "Goodwe",
  "wallbox.inactive.subtitle": "Neaktívny",
  "wallbox.mode.pv.batteryStopConflict.description": "Ak je zapnutá blokácia batérie pri prevádzke wallboxu, nie je možné zapnúť režim „Nabíjanie podľa batérie“. Pre zapnutie režimu „Nabíjanie podľa batérie“ je nutné najprv vypnúť blokáciu batérie na stránke „Fotovoltaika“.",
  "wallbox.mode.pv.batteryStopConflict.title": "Režim nie je možné zapnúť",
  "wallbox.mybox": "MyBox",
  "wallbox.none": "Žiadny",
  "wallbox.nonemode": "Bežné nabíjanie",
  "wallbox.nonemode.amper-auto": "Automatické riadenie nabíjacieho prúdu",
  "wallbox.nonemode.amper-auto.subtitle": "Riadi nabíjanie aby sa minimalizovalo nabíjanie a vybíjanie batérie",
  "wallbox.nonemode.ampers": "Maximálny nabíjací prúd",
  "wallbox.nonemode.hdo": "Nabíjanie len pri nízkom tarife",
  "wallbox.nonemode.hdo_sub": "Časy pre HDO musia byť nastavené v všeobecnom nastavení",
  "wallbox.nonemode.on": "Aktivní",
  "wallbox.nonemode.on_sub": "Auto sa nabíja čo najrýchlejšie",
  "wallbox.olife": "Olife",
  "wallbox.other": "Ostatné",
  "wallbox.pv.ampers-auto": "Aktuálny požadovaný nabíjací prúd",
  "wallbox.schedules.description": "Naplánujte si nabíjanie elektromobilu podľa potreby.",
  "wallbox.schedules.title": "Plánovač nabíjania",
  "wallbox.settings": "Nastavenie",
  "wallbox.solax": "Solax - komunikácia cez striedač",
  "wallbox.solax-ev-charger": "Solax - komunikácia cez Infigy",
  "wallbox.statistics": "Statistiky",
  "wallbox.status": "Režim Wallboxu",
  "wallbox.status.car_not_connected": "Auto nie je pripojené",
  "wallbox.status.charging": "Nabíjanie",
  "wallbox.status.charging_with_ventilation": "Nabíjanie auta s ventilátorom",
  "wallbox.status.error": "Chyba nabíjania",
  "wallbox.status.home": "Režim wallboxu",
  "wallbox.status.normal": "Bežný režim",
  "wallbox.status.not_connected": "Nemožno nadviazať spojenie",
  "wallbox.status.off": "Wallbox vypnutý",
  "wallbox.status.ready": "Pripravené na nabíjanie",
  "wallbox.sub_status.auto": "podľa auto. režimu",
  "wallbox.sub_status.basic_energy": "základní energií",
  "wallbox.sub_status.battery": "popodľa batérie",
  "wallbox.sub_status.battery_fast": "prednostne podľa batérie",
  "wallbox.sub_status.battery_waiting": ", čakanie na nabitie batérie",
  "wallbox.sub_status.hdo_block": ", blokácia HDO",
  "wallbox.sub_status.no_charging": ", nabíjanie je zakázané",
  "wallbox.sub_status.none": "",
  "wallbox.sub_status.photovoltaics": "podľa FVE",
  "wallbox.sub_status.schedule": "podľa plánovača",
  "wallbox.sub_status.spot": "podľa SPOTU",
  "wallbox.sub_status.spot_high": ", je vysoká cena SPOTU",
  "wallbox.sub_status.spot_mid": ", je stredná cena SPOTU",
  "wallbox.victron-ev-charger": "Victron EV Charger",
  "wallbox.wallboxes.title": "Wallboxy",
  "wallbox_rfid.add_button": "Pridané RFID kárty",
  "wallbox_rfid.delete.cancel": "Zrušiť",
  "wallbox_rfid.delete.confirm": "Zmazať",
  "wallbox_rfid.delete.confirm.title": "Zmazať kárty {name}?",
  "wallbox_rfid.dialog.already_exists": "Kárta {id} je už uložená pod názvom {name}.",
  "wallbox_rfid.dialog.already_exists_hint": "Pripnite ďalšiu kárdu alebo zavrite dialóg.",
  "wallbox_rfid.dialog.cancel": "Zrušiť",
  "wallbox_rfid.dialog.name_label": "Názov kárty",
  "wallbox_rfid.dialog.save": "Uložiť",
  "wallbox_rfid.dialog.scanned_id": "ID karty: {id}",
  "wallbox_rfid.dialog.title": "Pridané RFID kárty",
  "wallbox_rfid.dialog.waiting": "Pripnite kárdu u k čtečke…",
  "wallbox_rfid.edit.dialog.title": "Upraviť RFID kárty",
  "wallbox_wizard.cancel": "Zrušiť",
  "wallbox_wizard.custom_device_ip_address.alert": "Uistite sa prosím, že sa IP adresa wallboxu nebude meniť (napr. keď wallbox využíva adresu z DHCP).",
  "wallbox_wizard.custom_device_ip_address.input": "IP adresa wallboxu",
  "wallbox_wizard.multiple_wallboxes.alert": "Pre nastavenie viac wallboxov prosím kontaktujte linku podpory. Kontakt nájdete v technickej wiki Infigy.",
  "wallbox_wizard.multiple_wallboxes.label": "Viac wallboxov",
  "wallbox_wizard.open": "Nastavit wallbox",
  "wallbox_wizard.save": "Uložiť",
  "wallbox_wizard.title": "Nastavenie wallbox",
  "welcome.subtitle": "Aplikácia pre domácu a modernú energetiku na jednom mieste! Lorem ipsum dolor sit amet",
  "welcome.title": "Vitajte v Infigy!",
  "wifi_ap_config.interface_block.confirm.confirmation_text": "{blocked, select, true {Zablokovať} other {Odblokovať}}",
  "wifi_ap_config.interface_block.confirm.content": "Naozaj chcete {blocked, select, true {zablokovať} other {odblokovať}} WiFi?",
  "wifi_ap_config.interface_block.confirm.title": "Zmena stavu WiFi",
  "wifi_ap_config.passphrase_change.confirm.passphrase": "Heslo",
  "wifi_ap_config.passphrase_change.confirm.title": "Zmena hesla k WiFi",
  "wifi_ap_config.wifi_interface_blocked.button": "{blocked, select, true {Odblokovať} other {Zablokovať}}",
  "wifi_ap_config.wifi_interface_blocked.title": "Stav WiFi",
  "wifi_ap_config.wifi_interface_blocked.value": "{blocked, select, true {Zablokovaný} other {Aktívny}}",
  "wind.common": "Všeobecné informácie",
  "wind.common.battery_charged_total": "Celkom do batérie:",
  "wind.common.battery_power": "Výkon do batérie",
  "wind.common.power": "Aktuálny výkon",
  "wind.common.power_today": "Dnešná výroba:",
  "wind.common.power_total": "Celková výroba",
  "wind.common.power_year": "Ročná výroba:",
  "wind.common.resistor_power": "Výkon do odporu",
  "wind.statistics": "Statistiky",
  "wind.statistics.power": "Výkon vetnej elektrárne",
  "wind.statistics.wind_speed": "Rýchlosť vetra",
  "wind.status": "Režim vetnej elektrárne"
}